<template>
    <!-- Dashboard main container -->
    <div class="admin-dashboard">
        <!-- Page Heading -->
        <div class="title-bell-wrap">
            <h2 class="page-title" v-if="user && user.role === 'client'" :class="firstLoad ? 'loader-gap' : ''">
                {{ $t("adminDashboard.clientTitle") }}
            </h2>
            <!-- Client Notification Messeges -->
            <div v-if="localNotificationCount && user && user.role === 'client' && !firstLoad" class="unread-messages">
                <router-link :to="{ path: '/app/contact-us' }">
                    <div class="unread-messages-icon">
                        <i class="fa fa-bell" aria-hidden="true"></i> {{ localNotificationCount }}
                        <span>unread <span v-if="localNotificationCount === 1">message</span><span
                                v-if="localNotificationCount > 1">messages</span>
                        </span>
                    </div>
                </router-link>
            </div>
        </div>
        <div class="loader-wrapper">
            <div class="user-details" v-if="user && calendar_view">
                <!-- Calendar Team -->
                <div class="calendar-team-name-container" v-if="adminDetails.group_owner || groupMemberAdmin">
                    <div class="calendar-team-name-wrapper">
                        <div class="calendar-team-name">
                            <div class="user-select-wrap" v-if="newIsGroup || groupMemberDisplayAll">
                                <label class="stylist-select-wrap" for="stylist-select">{{ newUsers[0].group_name }}
                                </label>
                                <select v-if="
                                    (newCurrentView == 'timeGridWeek' ||
                                        newCurrentView == 'dayGridMonth' ||
                                        newCurrentView == 'timeGridThreeDays' ||
                                        newCurrentView == 'resourceTimeGridDay') &&
                                    showStylistSpecificAppointments
                                " id="stylist-select" class="select-group-name" v-model="newCurrentStylistId"
                                    v-on:change="newOnStylistChange">
                                    <option v-for="(member, index) in newUsers" v-bind:key="index"
                                        v-bind:value="member.user.id" v-bind:disabled="member.active != 1">
                                        {{ member.user.first_name }}
                                        {{ member.user.last_name }}
                                    </option>
                                </select>
                            </div>
                            <div class="control-btns-container">
                                <div v-if="
                                    (newIsGroup || groupMemberDisplayAll) &&
                                    (newCurrentView == 'timeGridWeek' ||
                                        newCurrentView == 'dayGridMonth' ||
                                        newCurrentView == 'timeGridThreeDays' ||
                                        newCurrentView == 'resourceTimeGridDay') &&
                                    showStylistSpecificAppointments
                                " class="controls-wrap">
                                    <button type="button" v-on:click="showAllAppts" class="primary-btn extra-small">
                                        Show All Appts.
                                    </button>
                                </div>
                                <div v-if="
                                    (newIsGroup || groupMemberDisplayAll) &&
                                    (newCurrentView == 'timeGridWeek' ||
                                        newCurrentView == 'dayGridMonth' ||
                                        newCurrentView == 'timeGridThreeDays' ||
                                        newCurrentView == 'resourceTimeGridDay') &&
                                    !showStylistSpecificAppointments
                                " class="controls-wrap">
                                    <button type="button" v-on:click="showStylistSpecificAppts"
                                        class="primary-btn extra-small">
                                        <span>Show </span>
                                        <span v-if="generalOptions.app_id == 1">Stylist</span>
                                        <span v-if="generalOptions.app_id == 2">Barber</span>
                                        <span> Specific Appt.</span>
                                    </button>
                                </div>
                                <div class="controls-wrap" v-if="
                                    (newIsGroup || groupMemberDisplayAll) &&
                                    (newCurrentView == 'timeGridWeek' ||
                                        newCurrentView == 'dayGridMonth' ||
                                        newCurrentView == 'timeGridThreeDays' ||
                                        newCurrentView == 'resourceTimeGridDay') &&
                                    showStylistSpecificAppointments
                                ">
                                    <button class="primary-btn extra-small" v-on:click="newOnStylistChange">
                                        <i class="fa fa-refresh" v-bind:class="{ 'fa-spin': loading }"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Calendar search and datepicker -->
                <div class="calendar-search-and-datepicker">
                    <div v-if="user.role != 'client'">
                        <div class="search-input-wrapper">
                            <div class="form-group has-search calendar-search-results">
                                <input v-model="searchQuery" v-on:input="searchAppointment"
                                    placeholder="Search by name or phone" type="search"
                                    class="text-field text-field-small search-input" />
                                <span v-if="
                                    filteredAppointments.length &&
                                    searchQuery &&
                                    !(searchQuery.length < 3) &&
                                    adminDetails.group_owner
                                " class="entries-found" v-cloak>
                                    ({{ filteredAppointments.length }} entries found)
                                </span>
                                <span v-if="
                                    filteredAppointments.length &&
                                    searchQuery &&
                                    !(searchQuery.length < 3) &&
                                    !adminDetails.group_owner
                                " class="entries-found-nogrup" v-cloak>
                                    ({{ filteredAppointments.length }} entries found)
                                </span>
                            </div>
                            <div v-if="user && user.role === 'stylist'" class="reports-notifications-wrapp">
                                <button class="calendar-view-wrapper"
                                    :class="!showStylistSpecificAppointments ? 'disabled-button' : ''"
                                    @click="handleNextCalendarView">
                                    <img src="../../assets/images/calendar-view.svg" alt="Change View">
                                </button>
                                <!--Reports-->
                                <router-link :to="{ path: '/app/reports/appts' }">
                                    <div class="reports-icon">
                                        <img src="../../assets/images/pie-chart.png" alt="Chart Pie">
                                    </div>
                                </router-link>
                                <!--Stylist Notification Messeges-->
                                <div class="unread-messages">
                                    <router-link :to="{ path: '/app/contact-us' }">
                                        <div class="unread-messages-icon">
                                            <i class="fa fa-bell-o" aria-hidden="true"></i>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <!--Calendar search results-->
                        <div v-if="searchQuery && !(searchQuery.length < 3) && !loading">
                            <div class="calendar-search-results calendar-search-container section-wrap">
                                <ul v-for="(item, index) in filteredAppointments" class="list-group"
                                    :key="filteredAppointments.id + '-' + index">
                                    <li class="list-group-item section-wrap">
                                        <div class="search-list-container">
                                            <span>
                                                Appt date:
                                                <span class="search-list-item-date">
                                                    {{ dateFullFormat(item.appt.date) }}
                                                    <span style="font-weight: bold">
                                                        ({{ item.appt.hour_begin }}
                                                        -
                                                        {{ item.appt.hour_end }})</span>
                                                </span>
                                            </span>
                                            <span>
                                                Duration:
                                                <span class="search-list-item-date">{{ item.appt.total_duration }}
                                                    min
                                                </span>
                                            </span>
                                            <span>
                                                Name:
                                                <span class="search-list-item-date">{{
                                                    item.appt.client.full_name
                                                    }}</span>
                                            </span>
                                            <span>
                                                Email:
                                                <span class="search-list-item-date">{{
                                                    item.appt.client.email || "-"
                                                    }}</span>
                                            </span>
                                            <span>
                                                Phone:
                                                <span class="search-list-item-date">{{
                                                    item.appt.client.full_phone_number_stripped || "-"
                                                    }}</span>
                                            </span>
                                            <span>
                                                Status:
                                                <span class="search-list-item-date">{{ item.appt.status }}</span>
                                            </span>
                                        </div>
                                        <div>
                                            <span type="button" class="primary-btn extra-small mobile" v-bind:style="item.appt.color
                                                ? {
                                                    backgroundColor: `${item.appt.color}`,
                                                    borderWidth: 1,
                                                    borderColor: `${item.appt.color}`,
                                                }
                                                : {}
                                                " v-on:click="
                                                    newOnEventClick({
                                                        event: { id: item.appt.id },
                                                        appt: item.appt,
                                                    })
                                                    ">
                                                View
                                            </span>
                                        </div>
                                    </li>
                                </ul>
                                <div v-if="!filteredAppointments.length && searchError && !loading" style="
                                        padding: 10px;
                                        min-height: 100px;
                                        display: flex;
                                        flex-direction: column;
                                        justify-content: center;
                                        align-items: center;
                                    ">
                                    <div style="
                                            display: flex;
                                            justify-content: center;
                                            text-align: center;
                                            font-weight: bold;
                                            color: rgb(178, 34, 34);
                                        ">
                                        {{ searchError }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Calendar appointments-->
                    <div class="calendar-appts">
                        <div v-if="appointmentRefreshTime && false" class="last-calendar-refresh-info">
                            <span class="last-refresh-appts-count">{{ appointmentRefreshTimeCounter }}</span>
                            <span>Refreshed at </span>
                            <span class="last-refresh-time">{{ appointmentRefreshTime }}</span>
                        </div>
                        <div class="calendar-choose-date-wrap">
                            <div v-if="showCalendarDateChoosePopup" class="calendar-choose-date"
                                :class="user && user.role == 'client' ? 'client' : 'stylist'">
                                <div class="datepicker-weeksminths-container">
                                    <div class="datepicker-container">
                                        <div class="datepicker-left-wrap">
                                            <datepicker v-on:selected="newOnDateClickFromFullCalendarDatePicker"
                                                :value="bookData.date" :inline="true">
                                            </datepicker>
                                        </div>
                                        <div class="datepicker-right-wrap">
                                            <datepicker v-on:selected="newOnDateClickFromFullCalendarDatePicker"
                                                :value="secondaryDatepickerDate" :inline="true">
                                            </datepicker>
                                        </div>
                                    </div>
                                    <div class="weeks-minths-options-wrap">
                                        <div class="options-wrap week-options-wrap">
                                            <span v-for="(opt, i) in 14" :key="`week-opt${i}`" v-on:click="
                                                newOnDateClickFromFullCalendarDatePicker(
                                                    addTimeToDate(new Date(), opt, 'W')
                                                )
                                                ">{{ opt }} weeks out</span>
                                        </div>
                                        <div class="options-wrap months-options-wrap">
                                            <span v-for="(opt, i) in 14" :key="`week-opt${i}`" v-on:click="
                                                newOnDateClickFromFullCalendarDatePicker(
                                                    addTimeToDate(new Date(), opt, 'M')
                                                )
                                                ">{{ opt }} months out</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="listing-view" v-if="user && user.role == 'client'">
                                <div @click="calendar_view = 0">
                                    <div class="primary-btn extra-small mobile">Listing View</div>
                                </div>
                            </div>
                        </div>
                        <div class="filters-unread-messages">
                            <div class="status-filters">
                                <div v-for="(status, i) in statusFilterTypes" :key="`status-button-${i}`">
                                    <div v-if="statusFilterTypeAppts[status].length != 0"
                                        v-on:click="openEventsByStatusModal(status)" :class="status"
                                        class="status-filter-button">
                                        {{ status }} ({{ statusFilterTypeAppts[status].length }})
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Appointments Calendar -->
                <div class="calendar-wrap section-wrap" :class="newCurrentView == 'resourceTimeGridDay' || newCurrentView == 'resourceTimeGridDay' ? 'onlyDayView' : ''
                    ">
                    <div :class="{ 'show-all-appts': !showStylistSpecificAppointments }">
                        <div class="day-before-date" v-if="newCurrentView == 'resourceTimeGridDay'"
                            :style="{ right: dayBeforeDateRight + '%' }">
                            {{ currentDay }},
                        </div>
                        <!--Calendar Component-->
                        <FullCalendar v-if="calendarReady" ref="fullCalendar" class="custom-calendar"
                            :options="calendarOptions" />
                        <MainLoader v-if="loadingView" class="calendar-loader section-wrap no-shadow" />
                    </div>
                    <!-- Pick-date modal -->
                    <div v-if="newShowFullCalendarDatePicker" class="fullcalendar-datepicker-wrapper">
                        <datepicker v-model="newCurrentDate" :inline="true" :time-config="{ enableTimePicker: false }"
                            :formats="{ preview: 'yyyy-MM-dd' }" :auto-apply="true"
                            @update:model-value="newOnDateClickFromFullCalendarDatePicker" />
                    </div>
                </div>
            </div>
        </div>
        <!-- Client loader -->
        <MainLoader v-if="user && user.role === 'client' && !calendar_view && firstLoad === true"
            class="section-wrap" />
        <!-- Client listings -->
        <div id="client-listing-view" v-if="!calendar_view && user && user.role == 'client' && !firstLoad">
            <div class="client-listing-view-container">
                <div class="book-listing-client-notifications-container">
                    <div class="book-new-appt-container">
                        <div class="book-btn-container">
                            <div class="book-btn" v-on:click="onBook()">
                                <div class="primary-btn extra-small mobile">Book</div>
                            </div>
                        </div>
                        <div v-if="
                            user.role == 'client' &&
                            clientWidgetSettings &&
                            clientWidgetSettings.stylist_name &&
                            Object.keys(dateAppointments).length == 0
                        " class="client-book-widget section-wrap">
                            <!--Client Widget-->
                            <div class="client-widget-header">
                                <div class="client-avatar-widget-header-container">
                                    <div v-if="clientWidgetSettings.stylist_avatar" class="stylist-avatar">
                                        <img :src="clientWidgetSettings.stylist_avatar"
                                            :alt="clientWidgetSettings.stylist_name" />
                                    </div>
                                    <div class="client-header-text">
                                        <p>
                                            Next available spots at
                                            <span>{{ clientWidgetSettings.stylist_name }}</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="widget-listing-wrap">
                                    <div class="client-widget-service">
                                        <!-- <v-select v-model="clientWidgetSelectedService" :options="clientWidgetServices"
                                            :reduce="(label) => label.value" @input="onClientWidgetServiceSelected" /> -->
                                        <vue-multiselect v-model="clientWidgetSelectedService"
                                            :options="clientWidgetServices" :track-by="'value'" :label="'label'"
                                            placeholder="Select a service" @input="onClientWidgetServiceSelected" />
                                    </div>
                                </div>
                            </div>
                            <!--Client widget quick appt days-->
                            <div class="client-widget-days">
                                <div v-for="(d, index) in clientWidgetDays" :key="index" class="client-widget-day">
                                    <div class="day-label">{{ d.date }}</div>
                                    <div v-if="d.slots.length > 0" class="day-slots" :class="{ loading: loading }">
                                        <span v-for="(s, i) in d.slots" :key="`${index}_${i}`"
                                            v-on:click="onClientWidgetSlotSlick(d.dateUnformatted, s)">{{ s }}</span>
                                    </div>
                                    <div v-if="d.slots.length == 0" class="day-slots">-</div>
                                </div>
                            </div>
                            <div class="client-more-dates-btn-container">
                                <router-link class="primary-btn extra-small mobile more-dates"
                                    :to="{ path: '/app/stylists' }">Click to see more
                                    dates</router-link>
                            </div>
                        </div>
                        <div v-if="Object.keys(dateAppointments).length > 0" class="book-appts-container section-wrap">
                            <div class="book-appt-wrapp" v-for="key in Object.keys(groupedEvents).sort()"
                                v-bind:key="key">
                                <div v-for="appt in groupedEvents[key]" v-bind:key="appt.id"
                                    class="appt-list-wrap no-shadow">
                                    <div class="appt-title-header">
                                        <h5 class="appt-title">
                                            {{ formatClientDate(key) }}
                                        </h5>
                                        <div class="appt-status-wrap">
                                            <span v-if="
                                                (appt.status !== 'unconfirmed' && appt.booked_by !== 'client') ||
                                                (appt.status === 'unconfirmed' && appt.booked_by === 'client')
                                            " :class="appt.status == 'unconfirmed'
                                                ? 'unconfirm-text'
                                                : 'hidden book-status-state'
                                                ">{{ capitalize(appt.status) }}</span>

                                            <div v-if="appt.status == 'unconfirmed' && appt.booked_by !== 'client'"
                                                class="primary-btn extra-small mobile"
                                                v-on:click="confirmAppointment(appt.id, false)">
                                                <i class="fa fa-calendar-check-o"></i>
                                                {{ $t("adminDashboard.confirm") }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="appt-list-inner">
                                        <div class="appt-date-time">{{ appt.start }} - {{ appt.end }}</div>
                                    </div>

                                    <div class="service-wrapp">
                                        <div v-for="(service, index) in appt.services_array" v-bind:key="index">
                                            <div class="service-name">
                                                <span v-if="appt.services_qty[index] > 1" class="qty">({{
                                                    appt.services_qty[index] }})
                                                </span>
                                                <span class="serv-title">{{ service }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="name-view-details-wrap">
                                        <div class="stylist-name">
                                            <a :href="appt.portfolio_page_url" class="main-text-link" target="_blank">{{
                                                appt.with_name
                                                }}</a>
                                        </div>

                                        <div class="appt-actions-wrap">
                                            <div v-on:click="viewAppointmentDetails(appt)"
                                                class="primary-btn extra-small mobile">
                                                View details
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Event Modal -->
        <div class="modal fade" id="event-modal" tabindex="-1" role="dialog" aria-labelledby="event-modal"
            data-backdrop="false" ref="eventModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <!--Flex element don't delete-->
                        <div v-if="showCheckout !== true"></div>
                        <div class="checkout-appt-id" v-if="showCheckout === true">
                            <h5>Complete Checkout</h5>
                            <div>ID: {{ selected_event.id }}</div>
                        </div>
                        <div>
                            <button type="button" v-on:click="resetData()" class="close" data-bs-dismiss="modal"
                                aria-label="Close">
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                    <!--Book Modal-->
                    <div class="modal-body book-sections no-padding-top">
                        <!-- Add Date and Time Edit -->
                        <div v-if="user && user.role == 'stylist' && !showCheckout" class="book-time-row">
                            <div class="">
                                <div class="member-avatar-global"
                                    v-if="selected_event && !selected_event.avatar && initials.length">
                                    <div>
                                        <span>{{ initials[0] }}</span>
                                        <span v-if="initials.length > 1">{{ initials[1] }}</span>
                                    </div>
                                </div>
                                <div class="member-avatar-global"
                                    v-if="selected_event && !selected_event.avatar && !initials.length">
                                    <img src="../../assets/images/rmb-logo.png" />
                                </div>
                            </div>
                            <div class="" v-if="bookData.personal != 1 && selected_event"
                                :class="selected_event.status === 'PERSONAL TIME OFF' ? 'hide-date-picker' : ''">
                                <div class="book-modal-day" v-on:click="openModal('pickApptDate')">
                                    <img width="25" height="25" src="../../assets/images/rounded-edit-icon.png"
                                        alt="Edit Icon" />
                                    <span><strong>{{ monthDateFormat(this.date) }} </strong></span>
                                </div>
                                <!-- pick-date modal -->
                                <div v-if="openApptDetailsDateModal" class="datepicker-wrapper appt-details-calendar">
                                    <datepicker :inline="true" :time-config="{ enableTimePicker: false }"
                                        :formats="{ preview: 'yyyy-MM-dd' }" :auto-apply="true"
                                        @update:model-value="onDateClickFromDatePicker" />
                                </div>
                                <div v-if="!newShowTimeSpinner" class="dropdown time-dropdown">
                                    <button class="dropdown-toggle book-dropdown-btn" type="button"
                                        id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                        <img width="25" height="25" src="../../assets/images/rounded-edit-icon.png"
                                            alt="Edit Icon" />
                                        <span class="show-time">{{ hour }}</span>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" id="time-dropdown">
                                        <a class="dropdown-item" href="#" v-for="(timeObj, i) in newTimeArray" :key="i"
                                            :class="{
                                                'free-time': timeObj.free,
                                                'taken-time': !timeObj.free,
                                                active: timeObj.value == hour,
                                            }" @click.prevent="changeTime(timeObj.value)">
                                            {{ timeObj.value }}
                                            <span class="ref"></span>
                                        </a>
                                    </div>
                                </div>
                                <div v-if="newShowTimeSpinner">
                                    <i class="fa fa-spinner fa-spin"></i>
                                </div>
                            </div>
                            <div class="">
                                <template v-if="selected_event && selected_event.status != 'canceled'">
                                    <div class="book-time-btn" v-if="
                                        user &&
                                        user.role !== selected_event.booked_by &&
                                        selected_event.status == 'unconfirmed'
                                    ">
                                        <button class="primary-btn extra-small mobile"
                                            v-on:click="confirmAppointment(selected_event.id)">
                                            <i class="fa fa-calendar-check-o"></i>
                                            {{ $t("adminDashboard.confirm") }}
                                        </button>
                                    </div>
                                    <span v-else class="appt-status" :class="{
                                        'bg-unconfirm': selected_event.status == 'unconfirmed',
                                        'bg-confirm': selected_event.status != 'unconfirmed',
                                    }">{{ capitalize(selected_event.status) }}</span>
                                </template>
                            </div>
                        </div>
                        <div v-if="user && user.role == 'client'" class="book-time-row" :class="user && user.role !== selected_event.booked_by && selected_event.status == 'unconfirmed'
                            ? 'book-time-client'
                            : ''
                            ">
                            <!--flex element dont delete-->
                            <div class="flex-elem"></div>
                            <div class="">
                                <template v-if="selected_event.status != 'canceled'">
                                    <div class="book-time-btn" v-if="
                                        user &&
                                        user.role !== selected_event.booked_by &&
                                        selected_event.status == 'unconfirmed'
                                    ">
                                        <div class="primary-btn extra-small mobile"
                                            v-on:click="confirmAppointment(selected_event.id)">
                                            <i class="fa fa-calendar-check-o"></i>
                                            {{ $t("adminDashboard.confirm") }}
                                        </div>
                                    </div>
                                    <span v-else-if="user && user.role !== 'client'" class="appt-status" :class="{
                                        'bg-unconfirm': selected_event.status == 'unconfirmed',
                                        'bg-confirm': selected_event.status != 'unconfirmed',
                                    }">{{ capitalize(selected_event.status) }}</span>
                                </template>
                            </div>
                        </div>
                        <div class="heading-checkout" v-if="showCheckout === true">
                            <div class="primary-btn extra-small mobile" @click="showCheckout = false">Back</div>
                        </div>
                        <!--Demo Client Checkout-->
                        <div v-if="user && user.role !== 'client' && !showCheckout">
                            <hr />
                        </div>
                        <div class="book-checkout" v-if="!showCheckout">
                            <div class="wrapper">
                                <div class="star-and-stylist-name">
                                    <div class="align-star-name">
                                        <div class="new-client-mark" v-if="
                                            user &&
                                            user.role === 'stylist' &&
                                            appointment_details.client_months_from_register < 6
                                        ">
                                            new
                                        </div>
                                        <div class="event-name" v-if="selected_event">
                                            {{ selected_event.with_name }}
                                        </div>
                                    </div>
                                    <div v-if="
                                        selected_event &&
                                        selected_event.client_phone &&
                                        selected_event.client_phone.indexOf('0000000000') == -1
                                    " class="event-name">
                                        {{ selected_event.client_phone }}
                                    </div>
                                    <div v-if="
                                        selected_event &&
                                        selected_event.client_email &&
                                        selected_event.client_email.indexOf('ringmystylist.com') == -1
                                    " class="event-name">
                                        {{ selected_event.client_email }}
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div v-if="
                                    !appointment_paid &&
                                    user &&
                                    user.role == 'stylist' &&
                                    selected_event &&
                                    selected_event.status != 'canceled' &&
                                    selected_event.status != 'PERSONAL TIME OFF'
                                " @click="showCheckout = true" class="primary-btn extra-small mobile">
                                    CHECKOUT
                                </div>
                            </div>
                            <div v-if="
                                (selected_event && selected_event.status == 'PERSONAL TIME OFF') ||
                                (selected_event &&
                                    selected_event.status != 'PERSONAL TIME OFF' &&
                                    bookData.personal == 1)
                            ">
                                <div @click="editPersonalAppt(selected_event)" class="primary-btn extra-small mobile">
                                    Edit
                                </div>
                            </div>
                        </div>
                        <div v-if="!showCheckout">
                            <hr />
                        </div>
                        <CompleteCheckoutModal v-if="showCheckout" :square_location_id="square_location_id"
                            :appointment_details="appointment_details" @on-modal-close="onModalClose">
                        </CompleteCheckoutModal>
                        <!--Payment-summary-->
                        <div class="payment-summary"
                            v-if="appointment_details.details && !showCheckout && !bookData.personal">
                            <div class="payment-wrap">
                                <h5>Payment Summary</h5>
                                <div class="payment-summary-label">
                                    <label>Total: </label><span>{{ appointment_details.total_price }} {{ currency
                                        }}</span>
                                </div>
                                <div class="payment-summary-label">
                                    <label>Paid: </label><span>{{
                                        appointment_details.details.total_payments
                                            ? appointment_details.details.total_payments
                                            : 0
                                    }}
                                        {{ currency }}</span>
                                </div>
                                <div v-if="balanceInfo.tip > 0" class="payment-summary-label">
                                    <label>Tip: </label><span>
                                        {{ balanceInfo.tip }} {{ currency }}</span>
                                </div>
                                <div class="payment-summary-label">
                                    <label>Balance: </label><span>
                                        {{ balanceInfo.balance }} {{ currency }}</span>
                                </div>
                            </div>

                        </div>
                        <!-- <div v-if="!bookData.personal">
                            <hr />
                        </div> -->
                        <div
                            v-if="!showCheckout && selected_event && selected_event.notes !== 'There were no notes made' && !bookData.personal">
                            <hr />
                        </div>
                        <div
                            v-if="selected_event && appointment_details && appointment_details.details && !showCheckout">
                            <span>Appt created on {{ dayOnApptWasCreated() }} at {{ hourOnApptWasCreated() }}</span>
                        </div>
                        <div class="scheduled" v-if="
                            selected_event &&
                            selected_event.status != 'PERSONAL TIME OFF' &&
                            bookData.personal == 0 &&
                            !showCheckout
                        ">
                            <div v-if="user && user.role == 'stylist' && adminDetails && adminDetails.group_members.length > 1"
                                class="scheduled-stylist-name">
                                <span>
                                    scheduled by {{ getBookedType(selected_event.booked_by, generalOptions.app_id) }}
                                </span>
                                <span>with {{ selected_event.stylist_name }}</span>
                            </div>
                            <span v-if="user && user.role == 'client'">
                                scheduled by {{ getBookedType(selected_event.booked_by, generalOptions.app_id) }}
                            </span>
                            <span v-if="
                                user &&
                                user.role == 'stylist' &&
                                (adminDetails.group_members.length == 0 || adminDetails.group_members.length == 1)
                            ">
                                scheduled by
                                {{ selected_event.booked_by == "stylist" ? "you" : selected_event.booked_by }}
                            </span>
                        </div>


                        <template v-if="!showCheckout">
                            <div class="event-modal-actions-wrap" v-if="
                                !appointment_paid &&
                                selected_event &&
                                selected_event.status != 'canceled' &&
                                selected_event.status != 'PERSONAL TIME OFF'
                            ">
                                <div class="" v-if="prevent_clients_reschedule == 0">
                                    <div v-if="!isPastEvent(selected_event.date)" class="primary-btn extra-small mobile"
                                        v-on:click="onRescheduleAppointment(selected_event.id)">
                                        <i class="fa fa-calendar-plus-o"></i>
                                        {{ $t("adminDashboard.reschedule") }}
                                    </div>

                                    <div v-if="isPastEvent(selected_event.date) && user && user.role === 'client'"
                                        @click="bookAgain(selected_event.userId)"
                                        class="primary-btn extra-small mobile">
                                        <i class="fa fa-retweet" aria-hidden="true"></i>
                                        {{ $t("adminDashboard.bookAgain") }}
                                    </div>
                                </div>
                                <div v-else></div>
                                <div class="">
                                    <div v-if="displayCancelButton(selected_event)" class="secondary-btn small mobile"
                                        v-on:click="onCancelAppointment(selected_event.id)">
                                        <i class="fa fa-calendar-times-o"></i>
                                        {{ $t("adminDashboard.cancel") }}
                                    </div>
                                </div>
                            </div>
                            <div class="event-modal-refund-wrap" v-if="appointment_details.details && appointment_details.details.refunded &&
                                appointment_paid &&
                                selected_event &&
                                selected_event.status != 'canceled' &&
                                selected_event.status != 'PERSONAL TIME OFF'
                            ">

                                <div v-if="displayCancelButton(selected_event)" class="secondary-btn small mobile"
                                    v-on:click="onCancelAppointment(selected_event.id)">
                                    <i class="fa fa-calendar-times-o"></i>
                                    {{ $t("adminDashboard.cancel") }}
                                </div>

                            </div>
                            <div class="recurring-active" v-if="
                                recurringDetails &&
                                recurringDetails.repeat_every > 0 &&
                                selected_event &&
                                selected_event.status != 'canceled'
                            ">
                                <span>Every {{ recurringDetails.repeat_every }} {{ recurringDetails.repeat_period
                                    }}<span v-if="recurringDetails.repeat_every > 1">s</span><span
                                        class="text-capitalize"
                                        v-if="recurringDetails.repeat_every == 1 && recurringDetails.repeat_period == 'day' && recurringDetails.repeat_week_days">
                                        ({{ recurringDetails.repeat_week_days.join(', ') }})</span>,
                                    ends {{ formatClientDate(recurringDetails.end_date) }}</span>
                            </div>
                            <div class="add-services-container"
                                v-if="newSelectedServices && newSelectedServices.length && selected_event"
                                id="services-listing">
                                <template v-if="!addServiceModal">
                                    <div class="add-service-wrapp">
                                        <div class="">
                                            Selected services (
                                            {{ hourMinutesFormat(newTotalDurationServices) }})
                                        </div>
                                        <div class="" v-if="
                                            !appointment_paid &&
                                            user &&
                                            user.role == 'stylist' &&
                                            selected_event.status != 'canceled'
                                        ">
                                            <a class="link primary-btn extra mobile" v-if="!editServices"
                                                @click="editServices = true">Edit</a>
                                            <a class="link primary-btn extra mobile" v-else
                                                @click="editServices = false">Save</a>
                                        </div>
                                    </div>
                                    <div class="services-container scroll-bar">
                                        <div class="" v-for="(service, index) in newSelectedServices"
                                            v-bind:key="index">
                                            <div class="selected-service-container">
                                                <div class="qty-service-name">
                                                    <span v-if="!editServices">{{ service.qty }} x </span>{{
                                                        service.name }}
                                                    <span v-if="service.user_id != user.id">(Shared
                                                        {{ service.is_product == 1 ? "Product" : "Service" }})</span>
                                                </div>
                                                <div class="service-duration">
                                                    <div class="service-duration-price">
                                                        <div class="modal-appt-service-select-wrap">
                                                            <!-- <span v-if="!editServices">
                                                                {{ service.qty }}
                                                                qty</span
                                                            > -->
                                                            <template v-if="editServices">
                                                                <select class="selectInput select-height"
                                                                    v-if="service.selected"
                                                                    v-model="selectedServiceQty[service.id]"
                                                                    v-on:change="
                                                                        setServiceQty($event, service.id);
                                                                    // saveService(service, index);
                                                                    ">
                                                                    <option :value="num" v-for="(num, i) in 10"
                                                                        :key="`opt-${i}`">
                                                                        {{ num }}
                                                                    </option>
                                                                </select>
                                                                <span></span>
                                                                <div class="service-duration-minutes">
                                                                    <span id="basic-addon-qty">qty</span>
                                                                </div>
                                                            </template>
                                                        </div>
                                                        <div v-if="
                                                            typeof service.is_product == 'undefined' ||
                                                            service.is_product == 0
                                                        ">
                                                            <span v-if="!editServices">
                                                                {{ hourMinutesFormat(service.duration) }}
                                                                -
                                                            </span>
                                                            <template v-else>
                                                                <div class="service-duration-wrapp">
                                                                    <input class="service-duration-input" type="number"
                                                                        @blur="saveService(service, index)"
                                                                        v-model="service.duration" />
                                                                    <div class="service-duration-minutes">
                                                                        <span id="basic-addon">min</span>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </div>
                                                        <div>
                                                            <span v-if="!editServices">
                                                                <span v-if="currency == 'USD'">${{
                                                                    service.price
                                                                        ? service.price
                                                                        : service.default_price
                                                                }}</span>
                                                            </span>
                                                            <span v-if="!editServices">
                                                                <span v-if="currency != 'USD'">{{
                                                                    service.price
                                                                        ? service.price
                                                                        : service.default_price
                                                                }}
                                                                    {{ currency }}</span>
                                                            </span>
                                                            <template v-else>
                                                                <div class="service-duration-wrapp">
                                                                    <input class="service-duration-input" type="number"
                                                                        @blur="saveService(service, index)"
                                                                        v-model="service.price" />
                                                                    <div class="service-duration-wrapp">
                                                                        <span v-if="currency == 'USD'"
                                                                            class="service-duration-minutes"
                                                                            id="basic-addon2">$</span>
                                                                        <span v-else class="service-duration-minutes">
                                                                            {{ currency }}</span>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </div>
                                                        <div class="service-delete" v-if="editServices"
                                                            @click="deSelectService(index)">
                                                            Delete
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="service-image-desc-container">
                                                    <div v-if="service.image != ''" class="service-image-modal">
                                                        <img width="80"
                                                            :src="getProductImage(service.image, service.user_id)"
                                                            class="product-image" />
                                                    </div>
                                                    <div>
                                                        {{ service.description }}
                                                    </div>
                                                </div>
                                            </div>
                                            <hr />
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <div v-if="selected_event && selected_event.notes !== 'There were no notes made'"
                                class="note-wrapper">
                                <h5>Note</h5>
                                <div v-if="selected_event && selected_event.notes"
                                    :class="selected_event.notes.length < 100 ? 'bigger-text' : ''">
                                    {{ selected_event.notes }}
                                </div>
                                <br>
                                <div v-if="!bookData.personal">
                                    <hr />
                                </div>
                            </div>

                            <div class="add-services-container scroll-bar">
                                <template v-if="addServiceModal">
                                    <div v-for="(service, s) in selectedServicesArray" v-bind:key="'key' + s"
                                        :id="'key' + s">
                                        <div>
                                            <div class="toggle-wrapp" :class="service.selected ? 'active-service' : ''">
                                                <div class="">
                                                    <div class="">
                                                        <label class="switch">
                                                            <input type="checkbox" v-model="service.selected"
                                                                v-bind:id="service.id" v-bind:value="service.id"
                                                                v-on:change="newSaveService(false)"
                                                                class="appt-reminder" />
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="inner-toggle-container">
                                                    <div class="inner-toggle-wrapp">
                                                        <div v-if="service.service_name.length > 40"
                                                            v-tooltip="service.service_name">
                                                            <span>{{ service.service_name.substr(0, 40) + "..." }}
                                                                <span v-if="service.user_id != user.id">(Shared
                                                                    {{
                                                                        service.is_product == 1 ? "Product" : "Service"
                                                                    }})</span>
                                                            </span>
                                                        </div>
                                                        <div v-if="service.service_name.length <= 40">
                                                            <span>{{ service.service_name }}
                                                                <span v-if="service.user_id != user.id">(Shared
                                                                    {{
                                                                        service.is_product == 1 ? "Product" : "Service"
                                                                    }})</span>
                                                            </span>
                                                        </div>
                                                        <div v-if="displayPrices[newCurrentStylistId]">
                                                            <div v-if="currency == 'USD'">
                                                                ${{
                                                                    service.default_price > 0
                                                                        ? service.default_price
                                                                        : service.service_price
                                                                }}
                                                            </div>
                                                            <div v-else>
                                                                {{
                                                                    service.default_price > 0
                                                                        ? service.default_price
                                                                        : service.service_price
                                                                }}
                                                                {{ currency }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <div class="add-service-col" v-if="
                                    !addServiceModal &&
                                    !appointment_paid &&
                                    user &&
                                    user.role == 'stylist' &&
                                    selected_event &&
                                    selected_event.status != 'canceled' &&
                                    selected_event.status != 'PERSONAL TIME OFF' && !editServices
                                ">
                                    <a class="add-service" @click="addServiceApp(selected_event.id)"><i
                                            class="fa fa-plus pr-2"></i>Add Service</a>
                                </div>
                            </div>
                            <div class="add-service-btn-save"
                                :class="selectedServicesCount < 1 ? 'disabled-button' : ''"
                                v-if="addServiceModal && !editServices">
                                <a class="link primary-btn extra-small mobile" href="#" @click="saveServices">Save</a>
                            </div>
                            <div class="save-row" v-if="
                                !addServiceModal &&
                                !editServices &&
                                !appointment_paid &&
                                user &&
                                user.role == 'stylist' &&
                                selected_event &&
                                selected_event.status != 'canceled' &&
                                selected_event.status != 'PERSONAL TIME OFF'
                            ">
                                <div class="save-modal-btn">
                                    <button type="button" class="primary-btn extra-small mobile"
                                        v-on:click="newSaveAppointment">
                                        {{ $t("adminDashboard.save") }}
                                    </button>
                                </div>
                            </div>
                        </template>

                        <div class="" v-if="
                            (selected_event && selected_event.status == 'PERSONAL TIME OFF') ||
                            (selected_event &&
                                selected_event.status != 'PERSONAL TIME OFF' &&
                                bookData.personal == 1)
                        ">
                            <button v-if="displayCancelButton(selected_event)" class="secondary-btn"
                                v-on:click="onCancelAppointment(selected_event.id)">
                                {{ $t("adminDashboard.cancel") }}
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- Cancel Appt Modal Stylist -->
        <div class="modal fade" id="cancel-appt-modal" tabindex="-1" role="dialog" aria-labelledby="cancel-appt-modal"
            aria-hidden="true" ref="cancelApptModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-cancel-title">
                        <h5>Cancel appointment</h5>
                    </div>
                    <div class="modal-cancel-text">
                        <p>Why do you want to cancel?</p>
                    </div>
                    <div class="cancel-modal-body">
                        <div class="cancel-modal-btns-wrapper">
                            <button v-if="user && user.role != 'client'" v-on:click="cancelAppointment(false, true)"
                                class="primary-btn extra-small mobile">
                                No show
                                <span v-if="stylistPolicy && stylistPolicy.cancel && stylistPolicy.noshow_fee > 0">({{
                                    stylistPolicy.noshow_fee }}%)</span>
                            </button>

                            <button v-on:click="cancelAppointment(false, false)" class="primary-btn extra-small mobile">
                                Canceled
                            </button>
                        </div>
                        <div @click="handleCancelRecurring" class="cancel-recurring-wrap" v-if="recurring != 0">
                            <span id="cancelRecurring">Cancel reccuring</span>
                        </div>
                        <button @click="closeModal('cancel-appt-modal')" type="button" data-bs-dismiss="modal"
                            aria-label="Close" class="secondary-btn small mobile">
                            Don't cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Date Modal -->
        <div class="modal fade" id="date-modal" tabindex="-1" role="dialog" aria-labelledby="date-modal"
            data-backdrop="false" ref="dateModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-appt-header-container">
                            <!--Save btn modal-->
                            <div>
                                <button type="button" class="modal-appt-btn" v-bind:class="{
                                    'action-disabled': newDisableSave,
                                }" v-on:click="newSaveAppointment" data-bs-dismiss="modal" aria-label="Close">
                                    {{ $t("adminDashboard.save") }}
                                </button>
                            </div>
                            <div v-if="newCurrentStylist" class="modal-appt-btn">
                                {{ newCurrentStylist.user.first_name }} {{ newCurrentStylist.user.last_name }}
                            </div>
                            <!--Cancel btn modal-->
                            <div>
                                <button type="button" v-on:click="resetAppointmentModalData" class="modal-appt-btn"
                                    data-bs-dismiss="modal" aria-label="Close">
                                    {{ $t("adminDashboard.cancel") }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body book-sections scroll-bar">
                        <div class="modal-toggle-btn-wrapp">
                            <button :class="{ active: appointmentType === 'client' }"
                                @click="setAppointmentType('client')">
                                CLIENT APPT
                            </button>

                            <button :class="{ active: appointmentType === 'personal' }"
                                @click="setAppointmentType('personal')">
                                PERSONAL APPT
                            </button>
                        </div>
                        <div class="time-row">
                            <div class="time-row-container" v-on:click="openModal('pickDate')">
                                <div class="time-row-icon-container">
                                    <img width="25" height="25" src="../../assets/images/rounded-edit-icon.png" />
                                </div>
                                <div class="time-row-text-container">
                                    <span class="">{{ this.day }}, {{ this.date }}</span>
                                </div>
                            </div>
                            <!-- pick-date modal -->
                            <div v-if="openDateModal" class="datepicker-wrapper">
                                <datepicker v-model="date" :inline="true" :time-config="{ enableTimePicker: false }"
                                    :formats="{ preview: 'yyyy-MM-dd' }" :auto-apply="true"
                                    @update:model-value="onDateClickFromDatePicker" />
                            </div>
                            <!-- time drop down -->
                            <div class="">
                                <div v-if="!newShowTimeSpinner" class="dropdown time-dropdown">
                                    <button class="btn dropdown-toggle time-dropdown-container" type="button"
                                        id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                        <div class="dropdown-icon-button">
                                            <img width="25" height="25" src="../../assets/images/rounded-edit-icon.png"
                                                alt="Edit Icon" />
                                        </div>
                                        <div>
                                            <span class="show-time">{{ hour }}</span>
                                        </div>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" id="time-dropdown">
                                        <a class="dropdown-item" href="#" v-for="(timeObj, i) in newTimeArray" :key="i"
                                            :class="{
                                                'free-time': timeObj.free,
                                                'taken-time': !timeObj.free,
                                                active: timeObj.value == hour,
                                            }" @click.prevent="changeTime(timeObj.value)">
                                            {{ timeObj.value }}
                                            <span class="ref"></span>
                                        </a>
                                    </div>
                                    <div v-if="newShowTimeSpinner">
                                        <i class="fa fa-spinner fa-spin"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="!disable" class="modal-client" v-bind:class="{ 'action-disabled': disable }">
                            <div v-on:click="
                                openModal('client');
                            resetSearchClient();
                            " v-if="!newIsClientSelected" class="add-client-service">
                                {{ $t("adminDashboard.dateModel.addClient") }}
                            </div>
                            <div v-on:click="openModal('client')" v-if="newIsClientSelected" class="add-client-service">
                                <div class="add-client-service">
                                    <img width="25" height="25" src="../../assets/images/rounded-edit-icon.png"
                                        alt="Edit Icon" />
                                </div>
                                <div>
                                    {{ newSelectedModalClient.first_name }}
                                    {{ newSelectedModalClient.last_name }}
                                </div>
                            </div>
                            <!-- ADD client modal -->
                            <div id="add-client-modal" aria-labelledby="add-client-modal" aria-hidden="true"
                                data-backdrop="false">
                                <div role="document">
                                    <div class="modal-content client-modal">
                                        <div class="modal-body book-sections scroll-bar">
                                            <div v-if="!displayNewClientForm">
                                                <div class="form-group">
                                                    <span class="fa fa-search form-control-feedback add-client-search">
                                                    </span>
                                                    <input v-model="newSearch" v-on:keyup="getFreshClients()"
                                                        type="text"
                                                        class="text-field text-field-small text-field-extra-small"
                                                        placeholder="Search" />
                                                </div>
                                                <div class="add-new-client"
                                                    :class="newPagedClients.length === 0 ? 'no-border' : ''">
                                                    <span v-on:click="displayAddClientForm"><i class="fa fa-plus"
                                                            aria-hidden="true"></i> Add New</span>
                                                </div>
                                                <div>
                                                    <div>
                                                        <div v-for="(newPagedClient, index) in newPagedClients"
                                                            v-bind:key="index"
                                                            v-on:click="newSelectedClientF(newPagedClient)"
                                                            class="add-client-initials-container">
                                                            <div class="avatar-img" v-if="
                                                                !newPagedClient.first_name &&
                                                                !newPagedClient.last_name
                                                            ">
                                                                <img src="../../assets/images/rmb-logo.png" />
                                                            </div>
                                                            <div v-if="
                                                                newPagedClient.first_name ||
                                                                newPagedClient.last_name
                                                            ">
                                                                <div class="name-initials-container">
                                                                    <p class="name-initials mb-0">
                                                                        {{
                                                                            newPagedClient.first_name
                                                                                ? newPagedClient.first_name[0]
                                                                                : ""
                                                                        }}{{
                                                                            newPagedClient.last_name
                                                                                ? newPagedClient.last_name[0]
                                                                                : ""
                                                                        }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="col-10 pl-3 d-flex align-items-center">
                                                                {{
                                                                    newPagedClient.first_name
                                                                        ? newPagedClient.first_name
                                                                        : ""
                                                                }}
                                                                {{
                                                                    newPagedClient.last_name
                                                                        ? newPagedClient.last_name
                                                                        : ""
                                                                }}
                                                            </div>
                                                        </div>
                                                        <div class="section-wrap no-shadow"
                                                            v-if="newPagedClients.length === 0">
                                                            No client found
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row justify-content-center mt-3">
                                                    <button class="btn load-more"
                                                        v-if="newLoadMore[newCurrentStylistId]"
                                                        v-on:click="newGetClients(newCurrentStylist)">
                                                        Load More
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="new-client-form" v-if="displayNewClientForm">
                                                <div id="add-new-client-form" ref="scrollTarget">Add new client</div>
                                                <div class="new-client-input">
                                                    <div class="add-new-client-input-wrap">
                                                        <input placeholder="Please enter first name*"
                                                            class="text-field text-field-small text-field-extra-small"
                                                            :class="{
                                                                'new-client-error': editClientObjErrors.first_name,
                                                            }" maxlength="20" v-model="editClientObj.first_name"
                                                            @input="clearError('first_name')" />
                                                    </div>
                                                    <div class="add-new-client-input-wrap">
                                                        <input placeholder="Please enter last name*"
                                                            class="text-field text-field-small text-field-extra-small"
                                                            :class="{
                                                                'new-client-error': editClientObjErrors.last_name,
                                                            }" maxlength="20" v-model="editClientObj.last_name"
                                                            @input="clearError('last_name')" />
                                                    </div>
                                                </div>
                                                <span class="phone-error-message" v-if="editClientObj.phone.length > 0">
                                                    {{ phoneError }}
                                                </span>
                                                <div class="new-client-input">
                                                    <div class="add-new-client-input-wrap">
                                                        <input placeholder="Please enter phone*"
                                                            class="text-field text-field-small text-field-extra-small"
                                                            :class="{
                                                                'new-client-error':
                                                                    editClientObjErrors.phone || phoneError,
                                                            }" type="tel" pattern="^[0-9]*$" required
                                                            @keyup="validatePhoneNumber(editClientObj.phone)"
                                                            @input="clearError('phone')"
                                                            v-model="editClientObj.phone" />
                                                    </div>
                                                </div>
                                                <div class="new-client-input">
                                                    <div class="add-new-client-input-wrap">
                                                        <input placeholder="Please enter client email"
                                                            class="text-field text-field-small text-field-extra-small"
                                                            v-model="editClientObj.email" />
                                                    </div>
                                                </div>
                                                <div class="new-client-input-group"
                                                    v-if="adminDetails.group_active && adminDetails.group_owner && groupMembers.length > 1">
                                                    <div>Toggle the stylist to add the new client</div>
                                                    <div class="new-client-stylists-wrap section-wrap"
                                                        :class="{ 'center-loader': stylistsLoaded }">
                                                        <div class="new-client-toggle-container"
                                                            v-for="(member, index) in groupMembers" v-bind:key="index">
                                                            <label :for="index + 'member'" class="toggle-btn-width">
                                                                {{ member.user.first_name }}
                                                                {{ member.user.last_name }}
                                                            </label>
                                                            <div>
                                                                <label class="switch">
                                                                    <input :id="index + 'member'" type="checkbox"
                                                                        v-bind:id="member.user.id"
                                                                        v-bind:value="member.user.id"
                                                                        v-model="editClientStylists" :disabled="newCurrentStylist.user.id == member.user.id
                                                                            " />
                                                                    <span class="slider round"></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <!--Loader-->
                                                        <div v-if="stylistsLoaded" class="loader">
                                                            <i class="fa fa-3x fa-spinner fa-spin"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="new-client-buttons">
                                                    <button class="primary-btn extra-small mobile"
                                                        v-on:click="saveClient">
                                                        {{ $t("general.save") }}
                                                    </button>
                                                    <button class="secondary-btn small mobile"
                                                        v-on:click="resetClientObj()">
                                                        {{ $t("general.cancel") }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="!disable" v-bind:class="{ 'action-disabled': disable }" class="modal-client">
                            <div>
                                <div v-if="!newShowSelectedServices">
                                    <div v-on:click="openModal('service')" class="add-client-service">
                                        {{ $t("adminDashboard.dateModel.addService") }}
                                    </div>
                                </div>
                                <div v-if="newShowSelectedServices">
                                    <div v-on:click="openModal('service')">
                                        <div class="add-client-service">
                                            <div class="add-client-service-icon">
                                                <img class="selected-client" width="25" height="25 "
                                                    src="../../assets/images/rounded-edit-icon.png" alt="Edit Icon" />
                                            </div>
                                            <div class="selected-client">
                                                <div v-if="
                                                    newSelectedServicesString &&
                                                    newSelectedServicesString.length <= 40
                                                ">
                                                    {{ newSelectedServicesString }}
                                                </div>
                                                <div v-if="
                                                    newSelectedServicesString &&
                                                    newSelectedServicesString.length > 40
                                                ">
                                                    {{ newSelectedServicesString }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- ADD service modal      -->
                                <div id="add-service-modal" aria-labelledby="add-service-modal" data-backdrop="false">
                                    <div class="modal-dialog" role="document">
                                        <div class="modal-content">
                                            <div v-if="!displayNewServicesForm"
                                                class="modal-body book-sections scroll-bar">
                                                <div class="selected-service-wrap">
                                                    <div class="services-and-products">
                                                        <h5>Services and Products</h5>
                                                    </div>
                                                    <div v-if="newShowSelectedServices">
                                                        <button v-bind:class="{ 'action-disabled': newDisableSave }"
                                                            type="button" class="primary-btn extra-small extra mobile"
                                                            v-on:click="newSaveAppointment">
                                                            {{ $t("adminDashboard.save") }}
                                                        </button>
                                                    </div>
                                                </div>
                                                <div>
                                                    <span class="fa fa-search inner-service-search"></span>
                                                    <input v-on:keyup="newResultQuery" type="text" class="
                                                            text-field
                                                            search-placeholder-position
                                                            text-field-small text-field-extra-small
                                                        " placeholder="Search" v-model="newSearchQuery" />
                                                </div>
                                                <div>
                                                    <div class="services-products-heading"
                                                        :class="!hasServices ? 'no-border' : ''">
                                                        <h5>
                                                            {{ $t("adminDashboard.addListServicesTitle") }}
                                                        </h5>
                                                        <button @click="toggleAddNewServiceForm(false)"
                                                            class="add-new-service-button"><i class="fa fa-plus"
                                                                aria-hidden="true"></i> Add
                                                            new</button>
                                                    </div>
                                                    <div v-for="(service, i) in newServicesArray" v-bind:key="i"
                                                        :id="i">
                                                        <div>
                                                            <div class="modal-appt-service-category"
                                                                v-if="service.is_product === 0"></div>
                                                            <div class="toggle-service" v-if="service.is_product === 0">
                                                                <div class="service-toggle">
                                                                    <div>
                                                                        <label class="switch">
                                                                            <input type="checkbox"
                                                                                v-model="service.selected"
                                                                                v-bind:id="service.id"
                                                                                v-bind:value="service.id" v-on:change="
                                                                                    newSaveService(false, true)
                                                                                    " class="appt-reminder" />
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div class="modal-appt-service-select-wrap">
                                                                    <select class="selectInput selectInputExtraSmall"
                                                                        v-if="service.selected"
                                                                        v-on:change="setServiceQty($event, service.id)"
                                                                        v-model="selectedServiceQty[service.id]">
                                                                        <option :value="num" v-for="(num, i) in 10"
                                                                            :key="`item-${i}`">
                                                                            {{ num }}
                                                                        </option>
                                                                    </select>
                                                                </div>
                                                                <div>
                                                                    <div class="modal-appt-service-price-wrapp">
                                                                        <div v-if="service.name.length > 30"
                                                                            v-tooltip="service.name">
                                                                            <label @click="onSelectedService"
                                                                                :for="service.id"
                                                                                class="service-label">{{
                                                                                    service.name.substr(0, 30) + "..."
                                                                                }}
                                                                                <span
                                                                                    v-if="service.user_id != user.id">(Shared
                                                                                    Service)</span>
                                                                            </label>
                                                                        </div>
                                                                        <div v-if="service.name.length <= 30">
                                                                            <label @click="onSelectedService"
                                                                                :for="service.id" class="service-label">
                                                                                {{ service.name }}
                                                                                <span v-if="service.user_id != user.id">
                                                                                    (Shared Service)
                                                                                </span>
                                                                            </label>
                                                                        </div>
                                                                        <div v-if="displayPrices[newCurrentStylistId]">
                                                                            <label @click="onSelectedService"
                                                                                :for="service.id" class="service-label"
                                                                                v-if="currency == 'USD'">
                                                                                ${{ service.price }}
                                                                                <span v-if="service.price_and_up === 1">
                                                                                    and up
                                                                                </span>
                                                                            </label>
                                                                            <label :for="service.id"
                                                                                class="service-label"
                                                                                v-if="currency != 'USD'">
                                                                                {{ service.price }}
                                                                                {{ currency }}
                                                                                <span
                                                                                    v-if="service.price_and_up === 1">and
                                                                                    up</span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="section-wrap no-shadow" v-if="!hasServices">
                                                        No service found
                                                    </div>
                                                </div>
                                                <div class="services-products-heading"
                                                    :class="!hasProducts ? 'no-border' : ''">
                                                    <h5>
                                                        {{ $t("adminDashboard.addListProductsTitle") }}
                                                    </h5>
                                                    <button @click="toggleAddNewServiceForm(true)"
                                                        class="add-new-service-button"><i class="fa fa-plus"
                                                            aria-hidden="true"></i> Add new</button>
                                                </div>
                                                <div v-for="(service, j) in newServicesArray" v-bind:key="'p' + j"
                                                    :id="'p' + j">
                                                    <div>
                                                        <div class="modal-appt-service-category"
                                                            v-if="service.is_product === 1"></div>
                                                        <div class="toggle-service" v-if="service.is_product === 1">

                                                            <div>
                                                                <label class="switch">
                                                                    <input @click="onSelectedService" type="checkbox"
                                                                        v-model="service.selected"
                                                                        v-bind:id="service.id" v-bind:value="service.id"
                                                                        v-on:change="newSaveService(false, true)"
                                                                        class="appt-reminder" />
                                                                    <span class="slider round"></span>
                                                                </label>
                                                            </div>

                                                            <div class="modal-appt-service-select-wrap">
                                                                <select class="selectInput selectInputExtraSmall"
                                                                    v-if="service.selected"
                                                                    v-on:change="setServiceQty($event, service.id)"
                                                                    v-model="selectedServiceQty[service.id]">
                                                                    <option :value="num" v-for="(num, i) in 10"
                                                                        :key="`item-${i}`">
                                                                        {{ num }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                            <div>
                                                                <div class="modal-appt-service-price-wrapp">
                                                                    <div v-if="service.name.length > 30" class=""
                                                                        v-tooltip="service.name">
                                                                        <label @click="onSelectedService"
                                                                            :for="service.id" class="service-label">{{
                                                                                service.name.substr(0, 30) + "..." }}
                                                                            <span
                                                                                v-if="service.user_id != user.id">(Shared
                                                                                Product)</span>
                                                                        </label>
                                                                    </div>
                                                                    <div v-if="service.name.length <= 30" class="">
                                                                        <label @click="onSelectedService"
                                                                            :for="service.id" class="service-label">{{
                                                                                service.name }}
                                                                            <span
                                                                                v-if="service.user_id != user.id">(Shared
                                                                                Product)</span>
                                                                        </label>
                                                                    </div>
                                                                    <div v-if="displayPrices[newCurrentStylistId]">
                                                                        <label @click="onSelectedService"
                                                                            :for="service.id" class="service-label"
                                                                            v-if="currency == 'USD'">
                                                                            ${{ service.price }}
                                                                            <span v-if="service.price_and_up === 1">and
                                                                                up</span>
                                                                        </label>
                                                                        <label :for="service.id" class="service-label"
                                                                            v-if="currency != 'USD'">
                                                                            {{ service.price }}
                                                                            {{ currency }}
                                                                            <span v-if="service.price_and_up === 1">and
                                                                                up</span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="section-wrap no-shadow" v-if="!hasProducts">
                                                    No product found
                                                </div>
                                            </div>

                                            <!-- Add new service/product form -->
                                            <div class="new-service-form-wrapper" v-if="displayNewServicesForm">
                                                <form class="new-service-form" @submit.prevent="handleSubmitSaveService"
                                                    ref="scrollTarget">
                                                    <h5>Add new {{ isAddingProduct ? 'product' : 'service' }}</h5>

                                                    <!-- Service/Product Name -->
                                                    <input v-model="addServiceFormObj.name" type="text"
                                                        :placeholder="`Please enter ${isAddingProduct ? 'product' : 'service'} name*`"
                                                        :class="['text-field', 'text-field-small', 'text-field-extra-small', { 'error-border': addServiceFormObjError.name }]" />

                                                    <!-- Price -->
                                                    <input v-model.number="addServiceFormObj.price" type="number"
                                                        step="0.01" min="0" placeholder="Please enter price*"
                                                        :class="['text-field', 'text-field-small', 'text-field-extra-small', { 'error-border': addServiceFormObjError.price }]" />

                                                    <!-- Duration -->
                                                    <input v-if="!isAddingProduct" v-model="addServiceFormObj.duration"
                                                        type="text" placeholder="Please enter duration* (e.g. 30 min)"
                                                        :class="['text-field', 'text-field-small', 'text-field-extra-small', { 'error-border': addServiceFormObjError.duration }]" />

                                                    <!-- Buttons -->
                                                    <div class="new-client-buttons">
                                                        <button type="submit" class="primary-btn extra-small mobile">
                                                            {{ $t("general.save") }}
                                                        </button>

                                                        <button type="button" class="secondary-btn small mobile"
                                                            @click="toggleAddNewServiceForm">
                                                            {{ $t("general.cancel") }}
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="!disable" class="service-cost-container"
                            v-bind:class="{ 'action-disabled': disable }">
                            <div>
                                <div v-if="!newShowTotalCost" class="service-cost-wrapper">
                                    <div>
                                        {{ $t("adminDashboard.dateModel.serviceCost") }}
                                    </div>
                                    <div v-if="currency == 'USD'">$0.00</div>
                                    <div v-if="currency != 'USD'">0.00 {{ currency }}</div>
                                </div>

                                <div v-if="newShowTotalCost" class="service-cost-wrapper">
                                    <div>
                                        {{ $t("adminDashboard.dateModel.serviceCost") }}
                                    </div>
                                    <div v-if="currency == 'USD'">${{ this.newTotalCostServices }}</div>
                                    <div v-if="currency != 'USD'">
                                        {{ this.newTotalCostServices }}
                                        {{ currency }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="!disable" class="service-client-confirmed-appt-container"
                            v-bind:class="{ 'action-disabled': disable }">
                            <div>
                                <div class="service-client-confirmed-appt-wrapper">
                                    <label for="client-confirmed">{{
                                        $t("adminDashboard.dateModel.clientConfirmed")
                                        }}</label>
                                    <label class="switch">
                                        <input type="checkbox" v-model="clientConfirmed" :value="clientConfirmed"
                                            id="client-confirmed" class="service-client-confirmed" />
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div v-if="!newRescheduleInProgress" class="recurring-event-container" v-bind:class="{
                            'action-disabled': newRescheduleInProgress,
                        }">
                            <div>
                                <div class="recurring-event-wrapper">
                                    <div>Recurring Event</div>
                                    <label class="switch">
                                        <input type="checkbox" v-model="recurring" v-bind:value="recurring"
                                            class="appt-reminder" />
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div v-if="!newRescheduleInProgress" class="recurring-inner-content-container" v-bind:class="{
                            'action-disabled': newRescheduleInProgress,
                        }">
                            <div>
                                <div>
                                    <div v-if="recurring">
                                        <div class="recurring-inner-content-wrapper">
                                            <div class="label-width">
                                                <label for="repeat-every">Repeat every: </label>
                                            </div>
                                            <div v-if="repeatPeriod !== 'day'">
                                                <input type="number"
                                                    class="text-field text-field-small recurring-input-width"
                                                    id="repeat-every" v-model="repeatEvery" min="0"
                                                    oninput="validity.valid||(value='');" max="99" />
                                            </div>
                                            <div class="label-width" v-else>
                                                <select class="selectInput selectInputExtraSmall" v-model="repeatEvery">
                                                    <option :value="num" v-for="(num, i) in repeatPeriodsDays"
                                                        :key="`item-${i}`">
                                                        {{ num }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="label-width">
                                                <div class="dropdown">
                                                    <button class="selectInput selectInputSmall dropdown-toggle"
                                                        type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                                        aria-expanded="false">
                                                        {{ repeatPeriod }}
                                                    </button>

                                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                        <li v-for="(period, index) in repeatPeriods" :key="index">
                                                            <button class="dropdown-item" type="button"
                                                                @click="changeRepeatPeriod(period)">
                                                                {{ period }}
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="repeatPeriod == 'day' && repeatEvery == 1"
                                            class="recurring-inner-content-wrapper cols-7">
                                            <label v-for="(day, i) in repeatPeriodWeekdays" :key="`weekday-${i}`">
                                                <input type="checkbox" name="repeatWeekdays[]" :value="day"
                                                    v-model="repeatWeekdays">
                                                {{ day[0].toUpperCase() }}
                                            </label>
                                        </div>

                                        <div class="recurring-inner-content-wrapper">
                                            <div class="label-width">
                                                <label for="occurrences">Ends after:</label>
                                            </div>
                                            <div>
                                                <input type="number"
                                                    class="text-field text-field-small recurring-input-width"
                                                    id="occurrences" v-model="repeatTimes" min="0" max="99"
                                                    oninput="validity.valid||(value='');" />
                                            </div>
                                            <div>
                                                <label for="occurrences">occurrences</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="!disable" class="note-row-container">
                            <div>
                                <div class="note-row-wrapper">
                                    <div>
                                        {{ $t("adminDashboard.dateModel.note") }}
                                    </div>
                                    <div class="input-group">
                                        <input type="text" class="text-field text-field-small text-field-extra-small"
                                            placeholder="Enter notes" aria-label="Username"
                                            aria-describedby="basic-addon1" v-model="notes" maxlength="100" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- notes for personal appointment -->
                        <div v-if="disable" class="note-row">
                            <label for="personalNotes">{{ $t("adminDashboard.dateModel.notes") }} ({{
                                $t("adminDashboard.dateModel.optional")
                                }})</label>
                            <textarea class="form-control" id="personalNotes" rows="9" v-model="notes"
                                placeholder="Write your notes!" maxlength="1000"></textarea>
                        </div>
                        <div class="duration-row-container duration-row">
                            <div>
                                <div class="duration-row-wrapper">
                                    <div>
                                        {{ $t("adminDashboard.dateModel.duration") }}
                                    </div>
                                    <div class="duration-row-plus-minus-container">
                                        <div v-on:click="changeDuration(false)" class="minus">
                                            <i class="fa fa-minus"></i>
                                        </div>
                                        <div v-on:click="changeDuration(true)" class="plus">
                                            <i class="fa fa-plus"></i>
                                        </div>
                                    </div>
                                    <div class="duration-minutes-box">{{ newTotalDurationServices }} min</div>
                                </div>
                            </div>
                        </div>
                        <div class="save-row-container">
                            <button v-bind:class="{
                                'action-disabled': newDisableSave,
                            }" type="button" class="primary-btn extra-small" v-on:click="newSaveAppointment">
                                {{ $t("adminDashboard.save") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Event by Status Modal -->
        <div class="modal fade" id="event-by-status-modal" tabindex="-1" role="dialog"
            aria-labelledby="event-by-status-modal" aria-hidden="true" data-backdrop="false">
            <div class="modal-dialog event-by-status-modal" role="document">
                <div class="modal-content">
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                        <i @click="closeModal('event-by-status-modal')" class="fa fa-times" aria-hidden="true"></i>
                    </button>
                    <div class="modal-header">
                        {{ currentStatusFilter === "recurring" ? "Next Recurring Appts" : currentStatusFilter }}
                    </div>
                    <div class="modal-body book-sections scroll-bar">
                        <div class="event-filter-range">
                            {{ currentStatusFilterInterval }}
                        </div>
                        <div class="events-container">
                            <div v-for="(event, i) in statusFilterTypeAppts[currentStatusFilter]"
                                :key="`filtered-event-${i}`" class="event-card">

                                <div class="header-body-wrapper">
                                    <!-- Header -->
                                    <div class="event-header">
                                        <div class="event-index">
                                            {{ i + 1 }}.
                                        </div>
                                        <div class="event-stylist">
                                            {{ event.stylist_name }}
                                        </div>
                                    </div>

                                    <!-- Body -->
                                    <div class="event-body">
                                        <div class="event-client">
                                            {{ event.with_name }}
                                        </div>

                                        <div class="event-services">
                                            {{ processServicesDisplay(event.services) }}
                                        </div>
                                        <div class="event-services">Appointment ID {{ event.id }}</div>

                                        <div class="event-date">
                                            <span>{{ formatEventDate(event.date) }}</span>

                                            <div v-if="event.recurring" class="event-recurring">
                                                Every {{ event.repeat_every }} {{ event.repeat_period }},
                                                ends {{ formatClientDate(event.end_date) }}
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <!-- Actions -->
                                <div class="event-actions">
                                    <!-- Unconfirmed -->
                                    <template v-if="event.status === 'unconfirmed'">

                                        <div class="full-width">
                                            <div v-if="user && user.role !== event.booked_by">
                                                <button class="primary-btn extra-small"
                                                    @click="confirmAppointment(event.id)">
                                                    <i class="fa fa-calendar-check-o"></i>
                                                    {{ $t("adminDashboard.confirm") }}
                                                </button>
                                            </div>

                                            <div>
                                                <button class="secondary-btn small" @click="newOnEventClick({
                                                    event: {
                                                        id: event.id,
                                                        extendedProps: { user_id: event.stylist_id },
                                                    },
                                                    appt: event.id,
                                                })">
                                                    View
                                                </button>
                                            </div>
                                            <!-- <button v-if="event && event.booked_by === 'stylist'"
                                            
                                                class="secondary-btn small" @click="runTest(event, 'schedule')">
                                                Reminder
                                            </button> -->

                                            <button v-if="event && event.booked_by === 'stylist'"
                                                class="secondary-btn small"
                                                @click="handleUnconfirmedAppointmentReminder(event)">
                                                Reminder
                                            </button>

                                        </div>

                                    </template>

                                    <!-- Confirmed -->
                                    <template v-else>
                                        <button class="primary-btn extra-small" @click="newOnEventClick({
                                            event: { id: event.id },
                                            appt: event.id,
                                        })">
                                            View
                                        </button>
                                    </template>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Unconfirmed Appointment Reminder -->
        <div class="modal fade" id="unconfirmed-appt-reminder" tabindex="-1" aria-labelledby="unconfirmedApptLabel"
            aria-hidden="true">

            <div class="modal-dialog modal-dialog-centered reminder-modal">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title" id="unconfirmedApptLabel">
                            <i class="fa fa-commenting me-2"></i>
                            Send SMS Reminder
                        </h5>

                        <button type="button" class="btn-close" data-bs-dismiss="modal"
                            @click="closeModal('unconfirmed-appt-reminder')">
                        </button>
                    </div>

                    <div class="modal-body">

                        <div class="reminder-icon">
                            <i class="fa fa-envelope"></i>
                        </div>

                        <p class="reminder-text" v-if="unconfirmedApptObj">
                            Send an SMS reminder to the {{ unconfirmedApptObj.with_name }} for their
                            <strong>unconfirmed appointment</strong>.
                        </p>

                        <div class="sms-warning">
                            <i class="fa fa-info-circle me-2"></i>
                            This will use <strong>1 SMS credit.</strong>
                        </div>

                    </div>

                    <div class="modal-footer">

                        <button type="button" class="secondary-btn small" data-bs-dismiss="modal">
                            Cancel
                        </button>

                        <button type="button" class="primary-btn extra-small" @click="sendSMSReminder()">
                            <i class="fa fa-paper-plane me-1"></i>
                            Send Reminder
                        </button>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import "bootstrap";
import auth from "./../../services/auth.js";
import api from "../../services/apiEndpoints.js";
import store from "./../../services/vuex.js";
import eventBus from "../../services/eventBus.js";
import moment from "moment";
import messages from "./../../services/messages.js";

import FullCalendar from '@fullcalendar/vue3';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';

import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

import general from "../../services/general.js";

import VueMultiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.css';

import { Modal } from "bootstrap";

import CompleteCheckoutModal from "./CompleteCheckoutModal.vue";
import MainLoader from "./general-components/MainLoader.vue";

// Mixins
import { fullcalendarMixin } from "../mixins/fullcalendar.js";
import { calendarViewMixin } from "../mixins/calendarView.js";
import { appointmentsMixin } from "../mixins/appointments.js";
import { servicesMixin } from "../mixins/services.js";
import { clientsMixin } from "../mixins/clients.js";
import { formatDataMixin } from "../mixins/formatData.js";

export default {
    name: "AdminDashboard",
    mixins: [fullcalendarMixin, calendarViewMixin, appointmentsMixin, servicesMixin, clientsMixin, formatDataMixin],
    data: function () {
        return {
            calendarOptions: {
                allDaySlot: false, // this controls the display of the all day slot on the calendar
                initialView: this.newCurrentView,// this sets the initial view of the calendar to month view, this will be changed to week or day view if the user selects a specific day or stylist
                initialDate: this.newCurrentDate, // this sets the initial date of the calendar to the current date, this will be changed to the selected date if the user selects a specific day
                headerToolbar: {
                    left: 'prev,next today',
                    center: 'title',
                    right: "dayGridMonth,timeGridWeek,timeGridThreeDays,resourceTimeGridDay",
                }, // this sets the buttons that are displayed on the calendar header and their order
                buttonText: {
                    today: 'Today',
                    dayGridMonth: 'Month',
                    timeGridWeek: 'Week',
                    timeGridThreeDays: '3 Days',
                    resourceTimeGridDay: 'Day'
                }, // this sets the text that is displayed on the calendar header buttons
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    interactionPlugin,
                    resourceTimeGridPlugin,
                    resourceTimelinePlugin,
                ], // this imports the necessary plugins for the calendar to function properly
                weekends: true, //  controls the display of weekends in the calendar
                events: [],// this will be populated with the appointments of the selected day and stylist
                slotDuration: "00:15:00", //controls the time intervals that are displayed on the calendar
                snapDuration: "00:15:00", //controls the time intervals that events snap to when being dragged or resized
                slotLabelInterval: "00:30:00",// controls the time intervals that are displayed on the calendar
                displayEventTime: true,// this controls whether the time of the event is displayed on the calendar
                slotMinTime: "00:00:00", // where the calendar hours starts
                slotMaxTime: "22:00:00", // where the calendar hours ends
                dayMaxEventRows: true, // limits the number of event rows displayed per day and shows a "more" link if there are too many events
                resources: [], // this will be populated with the stylists of the business and will be used to display the appointments of each stylist on the calendar
                firstDay: 1, // this sets the first day of the week to Sunday (0 = Sunday, 1 = Monday, etc.)
                editable: true, // this allows events to be dragged and resized on the calendar
                nowIndicator: true, // this displays a line on the calendar indicating the current time
                schedulerLicenseKey: import.meta.env.VITE_FULL_CALENDAR_LICENSE_KEY, // this is the license key for the full calendar scheduler plugin, this is required for the resource time grid view to work
                datesSet: this.datesSet, // this is the function that is called when the calendar view is changed or the date is changed, this will be used to fetch the appointments of the selected day and stylist
                dateClick: this.newOnDateClick, // this is the function that is called when a date is clicked on the calendar, this will be used to open the modal to create a new appointment
                eventClick: this.newOnEventClick, // this is the function that is called when an event is clicked on the calendar, this will be used to open the modal to view the appointment details
                eventResize: this.eventResize, // this is the function that is called when an event is resized on the calendar, this will be used to update the appointment details in the database
                eventDrop: this.eventDrop, // this is the function that is called when an event is dragged and dropped on the calendar, this will be used to update the appointment details in the database
                eventContent: this.eventContent, // this is the function that is called to render the content of an event on the calendar, this will be used to customize the display of the events on the calendar
                resourceLabelContent: this.resourceLabelContent, // this is the function that is called to render the content of a resource label on the calendar, this will be used to customize the display of the stylist names on the calendar
                height: 'auto',      // calendar grows to fit all content
                contentHeight: 'auto', // calendar grows to fit all content
                expandRows: true,     // expands rows instead of scrolling
                dayMaxEvents: true,        // shows "+X more" when too many events
                dayMaxEventRows: false,    // prevents row expansion
                eventDisplay: 'block',     // ensures block layout for events
                views: {
                    timeGridThreeDays: {
                        type: 'timeGrid',
                        duration: { days: 3 },
                    },
                }, // this adds a custom view for displaying 3 days in the time grid view

                resourceOrder: '',
            },
            firstLoad: false,
            calendarApptsReady: false,
            calendar_view: 1,
            calendarWeekends: true,
            displayEventTime: true,
            user: null,
            day: null,
            date: null,
            hour: null,
            newClientServices: {},
            newClients: {},
            newAppointments: {},
            dateAppointments: {},
            newDisabledTimes: {},
            newUsers: [],
            newCurrentView: null,
            newCurrentStylist: null,
            newCurrentDate: null,
            newIsGroup: false,
            groupMemberDisplayAll: false,
            groupAdminId: 0,
            newGroupId: 0,
            numberOfDataFetched: 0,
            totalNumberOfDataToFetchPerUser: 6,
            totalNumberOfDataToFetch: 0, //this will be variable = no of users * totalNumberOfDataToFetchPerUser
            newPauseBetweenAppointments: {},
            newBreakHours: {},
            newFreeDays: {},
            newFreeDaysTime: {},
            newExceptionDaysList: {},
            newServiceCategoryMapping: {},
            newColorCategoryMapping: {},
            newColors: [],
            newEvents: [],
            newResources: [],
            initialDetailsFetched: false,
            newCurrentStylistId: 0,
            newBusinessHours: {},
            newShowFullCalendarDatePicker: false,
            editServices: false,
            addService: true,
            addServiceModal: false,

            prevent_clients_reschedule: 0,

            defaultWorkSettings: {
                sunday_block_from: "",
                sunday_block_to: "",
                sunday_from: "09:00 AM",
                sunday_to: "05:00 PM",

                monday_block_from: "",
                monday_block_to: "",
                monday_from: "09:00 AM",
                monday_to: "05:00 PM",

                tuesday_block_from: "",
                tuesday_block_to: "",
                tuesday_from: "09:00 AM",
                tuesday_to: "05:00 PM",

                wednesday_block_from: "",
                wednesday_block_to: "",
                wednesday_from: "09:00 AM",
                wednesday_to: "05:00 PM",

                thursday_block_from: "",
                thursday_block_to: "",
                thursday_from: "09:00 AM",
                thursday_to: "05:00 PM",

                friday_block_from: "",
                friday_block_to: "",
                friday_from: "09:00 AM",
                friday_to: "05:00 PM",

                saturday_block_from: "",
                saturday_block_to: "",
                saturday_from: "09:00 AM",
                saturday_to: "05:00 PM",

                pause_between_appointments: 15,
                display_prices: 1,
            },
            newShowTimeSpinner: false,
            newTimeArray: [],
            newPage: {},
            newPagedClients: [],
            newLoadMore: {},
            originalLoadMore: {},
            newIsClientSelected: false,
            newSelectedModalClient: {},
            newSelectedServices: [],
            selectedServiceQty: {},
            newDisableSave: true,
            newSearch: "",
            newServicesArray: [],
            newSearchQuery: "",
            newFillteredService: [],
            newTotalCostServices: 0,
            newSelectedServicesString: "",
            newTotalDurationServices: 0,
            newShowSelectedServices: false,
            newShowTotalCost: false,
            newShowTotalDuration: false,
            newDisableSaveServices: true,
            selectedServicesArray: [],
            disable: false,
            selected_event: {},
            loading: false,
            apptClientSelected: true,
            openDateModal: false,
            notes: "",
            initials: [],
            newRescheduleInProgress: false,
            displayPrices: {},
            currentDay: "",
            currency: "USD",
            clientConfirmed: 0,
            recurring: 0,
            repeatEvery: 0,
            recurringDetails: [],
            repeatPeriod: "week",
            repeatPeriods: ["day", "week", "month"],
            repeatTimes: 0,
            fullCalendarLicenseKey: "",
            cancelRecurringButton: null,
            cancelAppointmentInProgressId: 0,
            memberColors: {},
            showStylistSpecificAppointments: true,
            displayNewClientForm: false,
            editClientStylists: [],
            editClientObj: {
                name: "",
                email: "",
                phone: "",
            },

            weeks_before: 6,
            weeks_after: 6,
            lastFetchedAppointmentDate: null,

            openApptDetailsDateModal: false,
            eventModalIsOpened: false,
            showRescheduleSave: false,

            personal: false,
            clientWidgetSettings: {
                stylist_id: 0,
                stylist_name: "",
                stylist_avatar: "",
            },
            clientWidgetDays: [],
            clientWidgetServices: [],
            clientWidgetSelectedService: null,
            clientWidgetRegularService: null,
            clientWidgetServiceDuration: 0,
            clientWidgetServicePrice: 0,
            dayBeforeDateRight: 0,
            showCheckout: false,
            appointment_details: [],

            stripeCards: [],
            squareCards: [],
            stripe: null,
            stripe_card: null,
            square_card: null,
            cardsLoaded: false,
            addingCard: false,
            stripe_client_secret: "",
            getting_stripe_client_secret: false,
            cards_errors: "",
            amount: 0,
            tips: 0,
            payment_email: "",
            payment_card: "",
            paymentProcess: false,
            showPaymentEmail: false,
            showSignature: false,
            square_location_id: '',
            appointment_paid: false,

            signatureOption: {
                penColor: "rgb(0, 0, 0)",
                backgroundColor: "rgb(255,255,255)",
            },

            supportMessages: [],
            searchQuery: "",
            filteredAppointments: [],
            searchError: false,
            executeNextLoopIn: 11000,
            initCalendar: false,
            appointmentRefreshTime: "",
            appointmentRefreshTimeCounter: 10,
            showCalendarDateChoosePopup: false,
            secondaryDatepickerDate: new Date(),
            statusFilterTypes: [
                "unconfirmed",
                "confirmed",
                "checked-in",
                "checked-out",
                "no-show",
                "cancellation",
                "total",
                "recurring",
            ],
            statusFilterTypeAppts: {
                unconfirmed: [],
                confirmed: [],
                "checked-in": [],
                "checked-out": [],
                "no-show": [],
                cancellation: [],
                total: [],
                recurring: [],
            },
            currentStatusFilter: "",
            currentStatusFilterInterval: "",
            eventRendering: false,
            eventRenderTimeout: null,
            currentCalendarView: "",

            currentDayNumber: 0,
            calendarViews: {
                DAY: 1,
                THREE_DAYS: 3,
                WEEK: 7,
                MONTH: 30,
            },
            apptPast: false,
            bookAgainStatus: false,
            editPersonalAppointment: false,
            client_contracts: {},
            hasNewContract: false,
            phoneError: "", // To store any validation errors
            editClientObjErrors: {
                first_name: null,
                last_name: null,
                phone: null,
            },
            stylistsLoaded: false,
            groupMemberAdmin: 0,
            hasProducts: false,
            hasServices: true,
            repeatPeriodDay: 1,
            repeatPeriodsDays: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            repeatPeriodWeekdays: [
                'sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'
            ],
            repeatWeekdays: [],
            displayNewServicesForm: false,

            addServiceFormObj: {
                name: "",
                price: null,
                duration: "",
            },
            addServiceFormObjError: {
                name: false,
                price: false,
                duration: false,
            },
            isAddingProduct: false,
            calendarReady: false,
            loadingView: false,
            appointmentType: 'client', // default
            unconfirmedApptObj: null,
        };
    },
    mounted: function () {
        // this.setInitialCalendarOptions();
        this.user = auth.state.user;
        this.scrollTop();

        if (this.user && this.user.role == "client") {
            this.calendar_view = 0;
        }
        this.initCalendar = true;

        this.$nextTick(() => {
            this.attachCalendarTitleClick()
        })

        //Restore the state for showStylistSpecificAppointments
        if (localStorage.getItem("ShowAllAppts") != null) {
            this.showStylistSpecificAppointments = false;
        } else {
            this.showStylistSpecificAppointments = true;
        }

        //STEP 1
        //determine if we are dealing with a group or a single user

        this.getUserSupportMessages();

        this.getSupportMessagesStatus();
        if (this.user.role == "client") {
            this.getLoggedInUserDetails();
            this.firstLoad = true;
        }

        //get the settings for the client widget
        if (this.user.role == "client") {
            this.getClientWidgetSettings();
        }

        eventBus.on("admin_sidebar_collapse", () => {
            setTimeout(() => {
                this.setDateLabelPos();
            }, 300);
        });

        this.currentDayNumber = this.getDayNumber();

        //Get the saved calendar view
        this.getCalendarView();

        this.openDateModalWithClientSet();
        this.newSetCurrentViewAndDate();
        this.populateCurrentViewAndDate();

        this.calendarOptions.resourceLabelContent = this.renderUserHeader;
        this.calendarOptions.initialView = this.newCurrentView;
        this.calendarOptions.initialDate = this.newCurrentDate;

        this.calendarReady = true; // render AFTER everything is ready

        const modal = this.$refs.eventModal;

        if (modal) {
            modal.addEventListener("show.bs.modal", this.handleModalShow);
            modal.addEventListener("hide.bs.modal", this.handleModalHide);
        }
        this.getClientsNotifications();
    },
    beforeDestroy() {
        eventBus.off("admin_details_loaded");
        eventBus.off("user_profile_loaded");

        const modal = this.$refs.eventModal;

        if (modal) {
            modal.removeEventListener("show.bs.modal", this.handleModalShow);
            modal.removeEventListener("hide.bs.modal", this.handleModalHide);
        }
    },
    computed: {
        adminDetails: {
            get() {
                return store.state.adminDetails;
            },
            set(value) {
                store.commit("setAdminDetails", value);
            },
        },
        groupMembers: {
            get() {
                return store.state.stylists;
            },
            set(value) {
                store.commit("setStylists", value);
            },
        },
        bookData: {
            get() {
                return store.state.bookData;
            },
            set(value) {
                store.commit("setBookData", value);
            },
        },
        previewData: {
            get() {
                return store.state.previewData;
            },
            set(value) {
                store.commit("setPreviewData", value);
            },
        },
        currentSection: {
            get() {
                return store.state.currentBookSection;
            },
            set(value) {
                store.commit("setBookSection", value);
            },
        },
        selectedStylist: {
            get() {
                return store.state.selectedStylist;
            },
            set(value) {
                store.commit("setSelectedStylist", value);
            },
        },
        selectedClient: {
            get() {
                return store.state.selectedClient;
            },
            set(value) {
                store.commit("setSelectedClient", value);
            },
        },
        stylistPolicy: {
            get() {
                return store.state.stylistPolicy;
            },
            set(value) {
                store.commit("setStylistPolicy", value);
            },
        },
        groupedEvents() {
            for (let i in this.dateAppointments) {
                if (this.dateAppointments[i].status == "canceled") {
                    delete this.dateAppointments[i];
                }
            }

            return _.groupBy(this.dateAppointments, "dayDate");
        },
        localNotificationCount: {
            get() {
                return store.state.localNotificationCount;
            },
            set(value) {
                store.commit("setLocalNotificationCount", value);
            },
        },
        selectedServicesCount() {
            return this.selectedServicesArray.filter(s => s.selected).length
        },
        balanceInfo() {
            const total = parseFloat(this.appointment_details?.total_price || 0);
            const paid = parseFloat(this.appointment_details?.details?.total_payments || 0);

            const rawBalance = total - paid;

            return {
                balance: rawBalance < 0 ? 0 : rawBalance,
                tip: rawBalance < 0 ? Math.abs(rawBalance) : 0
            };
        },
    },

    watch: {
        loadingView(newVal) {
            const calendarEl = document.querySelector('.fc-view-harness');
            if (calendarEl) {
                calendarEl.style.display = newVal ? 'none' : 'block';
            }
        }
    },
    methods: {
        datesSet(info) {
            this.loadingView = true;
            let promises = [];

            this.currentDay = moment(this.getFullCalendarApi().getDate()).format("ddd");
            this.resetStatusFilterTypeAppts();

            if (info && info.view.type === 'timeGridThreeDays') {
                this.saveCalendarView(this.calendarViews.THREE_DAYS);
            }

            if (info && info.view.type === 'resourceTimeGridDay') {
                this.saveCalendarView(this.calendarViews.DAY);
            }

            if (info && info.view.type === 'dayGridMonth') {
                this.saveCalendarView(this.calendarViews.MONTH);
            }

            if (info && info.view.type === 'timeGridWeek') {
                this.saveCalendarView(this.calendarViews.WEEK);
            }

            this.newEvents = [];

            if (
                typeof info.view != "undefined" &&
                typeof info.view.activeStart != "undefined" &&
                typeof info.view.type !== "undefined" &&
                info.view.type != "dayGridMonth" &&
                info.view.type != "timeGridWeek" &&
                info.view.type != "timeGridThreeDays"
            ) {
                localStorage.setItem("calendarDate", moment(info.view.activeStart).format("YYYY-MM-DD"));
            }

            if (!this.initialDetailsFetched) {
                if (this.user.role == "stylist") {
                    this.getLoggedInUserDetails();
                }
                this.initialDetailsFetched = true;
                return;
            }

            if (info.view.type !== this.currentCalendarView) {
                this.changeCurrentView(info.view.type);
            }

            let targetDate = null;
            if (
                typeof info != "undefined" &&
                typeof info.view != "undefined" &&
                typeof info.view.currentStart != "undefined"
            ) {
                targetDate = info.view.currentStart;
            }

            this.currentCalendarView = info.view.type;

            let currentDatetime = moment().format("YYYY-MM-DD h:mm a");
            let currentDate = moment(this.bookData.date).format("YYYY-MM-DD");

            let query =
                "?include_taken=1&stylist_id=" +
                this.newCurrentStylistId +
                "&date=" +
                currentDate +
                "&current_datetime=" +
                currentDatetime;

            const freeHoursPromise = this.$http.get(api.actions.get_stylist_free_hours + query)
                .then((response) => {
                    if (typeof response.data.free_hours != "undefined") {
                        this.newTimeArray = this.newProcessMakeTimeResponse(response);

                        let missingTimeArray = this.fillInMissingTimes(
                            this.newTimeArray[0],
                            this.newTimeArray[this.newTimeArray.length - 1]
                        );

                        this.newTimeArray = this.newTimeArray.concat(missingTimeArray);
                        this.newTimeArray.sort(function (obj1, obj2) {
                            return obj1.date - obj2.date;
                        });

                        let allFormattedTime = [];
                        this.newTimeArray.forEach(function (element) {
                            allFormattedTime.push(element.date);
                        });

                        this.newShowTimeSpinner = false;
                    }
                });

            promises.push(freeHoursPromise);

            switch (info.view.type) {
                case "dayGridMonth":
                case "timeGridWeek":
                case "timeGridThreeDays":
                    this.weeks_before = (info.view.type === "dayGridMonth") ? 6 : 1;
                    this.weeks_after = (info.view.type === "dayGridMonth") ? 6 : 1;
                    this.numberOfDataFetched = 0;
                    this.totalNumberOfDataToFetch = 2;

                    this.newGetDisabledTimes(this.newCurrentStylist);
                    promises.push(this.newGetAppointments(this.newCurrentStylist, targetDate));
                    break;

                case "resourceTimeGridDay":
                    this.weeks_before = 1;
                    this.weeks_after = 1;
                    this.numberOfDataFetched = 0;
                    this.totalNumberOfDataToFetch = 2 * this.newUsers.length;

                    this.newUsers.forEach((user) => {
                        this.newGetDisabledTimes(user);
                        promises.push(this.newGetAppointments(user, targetDate));
                    });
                    break;
            }

            Promise.all(promises)
                .then(() => {
                    return this.$nextTick(); // ✅ wait for DOM update
                })
        },

        getData() {
            //set calendar view to know if to fetch disabled times or not

            this.totalNumberOfDataToFetch = this.newUsers.length * this.totalNumberOfDataToFetchPerUser;

            this.newUsers.forEach((user) => {

                //make break hours, block from and block to
                this.newMakeDisabledData(user); //some static data to be used later

                this.newMakeServiceCategoryMapping(user);
                this.newMakeColorCategoryMapping(user);
                this.newGetServices(user);
                this.newGetClients(user, true);
                this.newGetAppointments(user, null, true);
                this.newGetDisabledTimes(user);

                //fetch disabled times only for week or day view
                if (this.newCurrentView == "dayGridMonth") {
                    this.numberOfDataFetched++;
                    this.newMakeEvents();
                }
            });
        },

        getLoggedInUserDetails() {
            this.$http.get(api.actions.get_stylist_details + this.user.id).then(
                function (response) {
                    if (typeof response.data.details !== "undefined") {
                        let userDetails = response.data.details;
                        if (
                            (userDetails.group_owner && userDetails.group_active) ||
                            (userDetails.group_member_admin && userDetails.group_active)
                        ) {
                            this.newIsGroup = true;
                            this.newGroupId = userDetails.group_id;
                            this.rightButtonLayout = "dayGridMonth,timeGridWeek,timeGridThreeDays,resourceTimeGridDay";
                        }

                        if (userDetails.group_member_display_all) {
                            this.groupMemberDisplayAll = true;
                            this.newGroupId = userDetails.group_id;
                            this.rightButtonLayout = "dayGridMonth,timeGridWeek,timeGridThreeDays,resourceTimeGridDay";
                            this.newCurrentStylistId = this.user.id;
                            this.groupAdminId = userDetails.group_owner_id;
                            this.showStylistSpecificAppointments = false;
                        }

                        this.groupMemberAdmin = userDetails.group_member_admin;
                        this.newColors = userDetails.colors;
                        this.newCurrentStylist = userDetails;
                        this.newCurrentStylistId = this.newCurrentStylist.user.id;

                        if (this.user.role == "client") {
                            this.newGetAppointments(this.newCurrentStylist);
                        }

                        //STEP 2
                        //create user array with one or multiple users
                        //based upon its a group or a single user
                        this.newUsers.push(userDetails);
                        this.createUserArray();

                        //get the currency
                        if (response.data.details.profile.currency) {
                            this.currency = response.data.details.profile.currency;
                        }
                    }
                }.bind(this)
            );
        },

        createUserArray() {
            // if (!this.newIsGroup && !this.groupMemberDisplayAll) {
            //     this.getData();
            //     return;
            // }

            if (!this.newIsGroup && !this.groupMemberDisplayAll) {

                this.newResources = [
                    {
                        id: this.newCurrentStylist.user.id,
                        title: this.newCurrentStylist.user.first_name,
                        imageurl: this.newCurrentStylist.profile.avatar
                    }
                ];

                this.calendarOptions.resources = this.newResources;

                this.newResourcesClone = _.clone(this.newResources);

                this.newPage[this.newCurrentStylist.user.id] = 1;
                this.newClients[this.newCurrentStylist.user.id] = [];

                this.getData();
                return;
            }

            this.$http.get(api.actions.get_stylist_group_members + this.newGroupId).then(
                function (response) {
                    if (typeof response.data.members != "undefined") {
                        this.newResources = [];
                        response.data.members.forEach((member, index) => {
                            if (member.active != 1) {
                                return;
                            }

                            this.memberColors[member.user.id] = this.getMemberColor(member, index);

                            if (member.user.id != this.newUsers[0].user.id) {
                                this.newUsers.push(member);
                            }
                            let resource = {
                                id: member.user.id,
                                title: member.user.first_name,
                                imageurl: member.profile.avatar,
                            };
                            this.newResources.unshift(resource);
                            this.newPage[member.user.id] = 1;
                            this.newClients[member.user.id] = [];
                        });

                        this.calendarOptions.resources = this.newResources;

                        this.newResourcesClone = _.clone(this.newResources);

                        this.filterMemberDisplayed(this.newCurrentStylistId);

                        this.newUsers = _.uniqBy(this.newUsers, function (el) {
                            return el.user.id;
                        });

                        this.getData();

                        if (!this.showStylistSpecificAppointments) {
                            this.filterMemberDisplayed(0);
                        }
                    }
                }.bind(this)
            );
        },

        filterMemberDisplayed(currentStylistId) {
            const calendarApi = this.getFullCalendarApi();

            // 1. Safety Check: If the clone doesn't exist yet, stop here.
            if (!this.newResourcesClone) {
                return;
            }

            if (currentStylistId === 0) {
                // Show ALL members
                this.newResources = [...this.newResourcesClone];
            } else {
                // Show ONE member
                this.newResources = this.newResourcesClone.filter(
                    member => member.id === currentStylistId
                );
            }

            // Ensure calendarApi exists before calling methods on it
            if (calendarApi) {
                calendarApi.setOption('resources', this.newResources);
                calendarApi.render();
            }
        },

        openEventsByStatusModal(status) {
            this.currentStatusFilter = status;

            var calendarApi = this.getFullCalendarApi();

            var view = calendarApi.view;
            var startTime = moment(view.currentStart).format("MMMM DD");
            var endTime = moment(view.currentEnd).subtract(12, "hours").format("MMMM DD");

            this.currentStatusFilterInterval = startTime + " - " + endTime;

            const eventByStatusModalEl = document.getElementById("event-by-status-modal");
            const eventByStatusModalInstance = Modal.getInstance(eventByStatusModalEl) || new Modal(eventByStatusModalEl);
            eventByStatusModalInstance.show();
        },

        getCurrentUserObject(cUser) {
            if (!this.newIsGroup) {
                return cUser;
            }

            let currentUser = cUser;

            this.newUsers.forEach((userProfile) => {
                if (userProfile.user.id == this.newCurrentStylistId) {
                    currentUser = userProfile;
                }
            });

            return currentUser;
        },

        resetLoop() {
            this.appointmentRefreshTimeCounter = 10;
            this.$data.executeNextLoopIn = 10000;
        },

        zeroPadNum(num, places) {
            var zero = places - num.toString().length + 1;
            return Array(+(zero > 0 && zero)).join("0") + num;
        },

        newGetDates(startDate, stopDate) {
            let dateArray = [];
            let currentDate = moment(startDate);
            stopDate = moment(stopDate);
            while (currentDate <= stopDate) {
                dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
                currentDate = moment(currentDate).add(1, "days");
            }
            return dateArray;
        },

        newProcessMakeTimeResponse(response) {
            if (typeof response.data.free_hours == "undefined") {
                return [];
            }

            let freeHours = response.data.free_hours;
            let takenHours = response.data.taken_hours;
            let timeArray = [];
            let timeArray2 = [];

            timeArray = freeHours.map((timeString) => {
                let obj = {
                    value: timeString,
                    free: true,
                    date: moment(this.newCurrentDate + " " + timeString, "YYYY-MM-DD hh:mm A").toDate(),
                };
                return obj;
            });

            timeArray2 = takenHours.map((timeString) => {
                let obj = {
                    value: timeString,
                    free: false,
                    date: moment(this.newCurrentDate + " " + timeString, "YYYY-MM-DD hh:mm A").toDate(),
                };
                return obj;
            });

            timeArray = timeArray.concat(timeArray2);
            timeArray.sort(function (obj1, obj2) {
                return obj1.date - obj2.date;
            });
            return timeArray;
        },

        newMakeDisabledData(user) {
            let userId = user.user.id;

            let workSetting = user.work_settings;

            if (typeof workSetting == "undefined" || workSetting == null) {
                workSetting = this.defaultWorkSettings;
            }
            this.newPauseBetweenAppointments[userId] = 0;
            if (typeof workSetting.pause_between_appointments != "undefined") {
                this.newPauseBetweenAppointments[userId] = workSetting.pause_between_appointments;
            } else {
                this.newPauseBetweenAppointments[userId] = this.defaultWorkSettings.pause_between_appointments;
            }

            if (typeof user.free_days != "undefined") {
                this.newFreeDays[userId] = user.free_days;
            }
            if (typeof user.free_days_time != "undefined") {
                this.newFreeDaysTime[userId] = user.free_days_time;
            }
            this.newBreakHours[userId] = [
                {
                    start: this.newGetFormattedBreakTimes(workSetting.sunday_block_from, "sunday_block_from"),
                    end: this.newGetFormattedBreakTimes(workSetting.sunday_block_to, "sunday_block_to"),
                },
                {
                    start: this.newGetFormattedBreakTimes(workSetting.monday_block_from, "monday_block_from"),
                    end: this.newGetFormattedBreakTimes(workSetting.monday_block_to, "monday_block_to"),
                },
                {
                    start: this.newGetFormattedBreakTimes(workSetting.tuesday_block_from, "tuesday_block_from"),
                    end: this.newGetFormattedBreakTimes(workSetting.tuesday_block_to, "tuesday_block_to"),
                },
                {
                    start: this.newGetFormattedBreakTimes(workSetting.wednesday_block_from, "wednesday_block_from"),
                    end: this.newGetFormattedBreakTimes(workSetting.wednesday_block_to, "wednesday_block_to"),
                },
                {
                    start: this.newGetFormattedBreakTimes(workSetting.thursday_block_from, "thursday_block_from"),
                    end: this.newGetFormattedBreakTimes(workSetting.thursday_block_to, "thursday_block_to"),
                },
                {
                    start: this.newGetFormattedBreakTimes(workSetting.friday_block_from, "friday_block_from"),
                    end: this.newGetFormattedBreakTimes(workSetting.friday_block_to, "friday_block_to"),
                },
                {
                    start: this.newGetFormattedBreakTimes(workSetting.saturday_block_from, "saturday_block_from"),
                    end: this.newGetFormattedBreakTimes(workSetting.saturday_block_to, "saturday_block_to"),
                },
            ];

            this.newBusinessHours[userId] = [
                {
                    start: this.newGetFormattedBreakTimes(workSetting.sunday_from, "sunday_from"),
                    end: this.newGetFormattedBreakTimes(workSetting.sunday_to, "sunday_to"),
                },
                {
                    start: this.newGetFormattedBreakTimes(workSetting.monday_from, "monday_from"),
                    end: this.newGetFormattedBreakTimes(workSetting.monday_to, "monday_to"),
                },
                {
                    start: this.newGetFormattedBreakTimes(workSetting.tuesday_from, "tuesday_from"),
                    end: this.newGetFormattedBreakTimes(workSetting.tuesday_to, "tuesday_to"),
                },
                {
                    start: this.newGetFormattedBreakTimes(workSetting.wednesday_from, "wednesday_from"),
                    end: this.newGetFormattedBreakTimes(workSetting.wednesday_to, "wednesday_to"),
                },
                {
                    start: this.newGetFormattedBreakTimes(workSetting.thursday_from, "thursday_from"),
                    end: this.newGetFormattedBreakTimes(workSetting.thursday_to, "thursday_to"),
                },
                {
                    start: this.newGetFormattedBreakTimes(workSetting.friday_from, "friday_from"),
                    end: this.newGetFormattedBreakTimes(workSetting.friday_to, "friday_to"),
                },
                {
                    start: this.newGetFormattedBreakTimes(workSetting.saturday_from, "saturday_from"),
                    end: this.newGetFormattedBreakTimes(workSetting.saturday_to, "saturday_to"),
                },
            ];

            this.newExceptionDaysList[userId] = user.exception_days_list;

            if (typeof workSetting.display_prices != "undefined") {
                this.displayPrices[userId] = workSetting.display_prices;
            } else {
                this.displayPrices[userId] = this.defaultWorkSettings.display_prices;
            }
        },

        newManageBreakHours(date, dayIndex, userId) {
            if (this.user.role == "client") {
                return;
            }
            if (
                typeof this.newBreakHours[userId][dayIndex] !== "undefined" &&
                typeof this.newBreakHours[userId][dayIndex]["start"] !== "undefined" &&
                this.newBreakHours[userId][dayIndex]["start"] !== "00:00:00" &&
                this.newBreakHours[userId][dayIndex]["start"] != "" &&
                typeof this.newBreakHours[userId][dayIndex]["end"] !== "undefined" &&
                this.newBreakHours[userId][dayIndex]["end"] !== "00:00:00" &&
                this.newBreakHours[userId][dayIndex]["end"] != ""
            ) {
                let object = {
                    start: date + " " + this.newBreakHours[userId][dayIndex]["start"],
                    end: date + " " + this.newBreakHours[userId][dayIndex]["end"],
                    type: "disabledTime",
                };
                return object;
            }
        },

        newManageBusinessHours(date, dayIndex, userId) {
            if (this.user.role == "client") {
                return;
            }

            if (
                typeof this.newBusinessHours[userId][dayIndex] !== "undefined" &&
                typeof this.newBusinessHours[userId][dayIndex]["start"] !== "undefined" &&
                this.newBusinessHours[userId][dayIndex]["start"] !== "" &&
                typeof this.newBusinessHours[userId][dayIndex]["end"] !== "undefined" &&
                this.newBusinessHours[userId][dayIndex]["end"] !== ""
            ) {
                // Set the exception day working hours
                if (
                    this.newExceptionDaysList[userId] &&
                    this.newExceptionDaysList[userId].length > 0
                ) {
                    let currentException = _.filter(
                        this.newExceptionDaysList[userId],
                        { date: date }
                    );

                    if (currentException.length > 0) {
                        let timeFrom =
                            currentException[0].work_from !== ""
                                ? currentException[0].work_from
                                : this.newBusinessHours[userId][dayIndex]["start"];

                        let timeTo =
                            currentException[0].work_to !== ""
                                ? currentException[0].work_to
                                : this.newBusinessHours[userId][dayIndex]["end"];

                        let exceptionFrom = moment(
                            date + " " + timeFrom,
                            "YYYY-MM-DD hh:mm A"
                        ).format("YYYY-MM-DD HH:mm:ss");

                        let exceptionTo = moment(
                            date + " " + timeTo,
                            "YYYY-MM-DD hh:mm A"
                        ).format("YYYY-MM-DD HH:mm:ss");

                        let objects = [
                            {
                                start: date + " 00:00:00",
                                end: exceptionFrom,
                                type: "disabledTime",
                            },
                            {
                                start: exceptionTo,
                                end: date + " 23:59:59",
                                type: "disabledTime",
                            },
                        ];

                        return objects;
                    }
                }

                // Otherwise go with the default working hours
                let objects = [
                    {
                        start: date + " 00:00:00",
                        end: date + " " + this.newBusinessHours[userId][dayIndex]["start"],
                        type: "disabledTime",
                    },
                    {
                        start: date + " " + this.newBusinessHours[userId][dayIndex]["end"],
                        end: date + " 23:59:59",
                        type: "disabledTime",
                    },
                ];

                return objects;
            }
        },

        newManageFreeTime(user) {
            let userId = user.user.id;

            let objects = [];
            if (this.newFreeDays[userId]?.length) {
                this.newFreeDays[userId].forEach((freeDate) => {
                    let date = moment(freeDate).format("YYYY-MM-DD");
                    let freeDayObject = {
                        start: date + " 00:00:00",
                        end: date + " 23:59:59",
                        type: "disabledTime",
                    };
                    objects.push(freeDayObject);
                });
            }

            if (this.newFreeDaysTime[userId]?.length) {
                this.newFreeDaysTime[userId].forEach((freeDateT) => {
                    let start = moment(freeDateT.date + " " + freeDateT.free_from, "YYYY-MM-DD hh:mm A").format(
                        "YYYY-MM-DD HH:mm:ss"
                    );

                    let end = moment(freeDateT.date + " " + freeDateT.free_to, "YYYY-MM-DD hh:mm A").format(
                        "YYYY-MM-DD HH:mm:ss"
                    );
                    let freeDayObject = {
                        start: start,
                        end: end,
                        type: "disabledTime",
                    };
                    objects.push(freeDayObject);
                });
            }
            return objects;
        },

        newOnStylistChange() {
            this.loading = true;
            this.newCurrentStylist = this.newUsers.find((user) => user.user.id == this.newCurrentStylistId);
            this.filterMemberDisplayed(this.newCurrentStylistId);
            this.numberOfDataFetched = 0;
            this.totalNumberOfDataToFetch = 2;
            this.newGetDisabledTimes(this.newCurrentStylist);
            this.newGetAppointments(this.newCurrentStylist);
            this.newPagedClients = this.newClients[this.newCurrentStylistId];
            this.newPage[this.newCurrentStylistId] = 2;
            this.newLoadMore[this.newCurrentStylistId] = this.originalLoadMore[this.newCurrentStylistId];
        },

        fillInMissingTimes(time1, time2) {
            let x = 15; //minutes interval
            let times = []; // time array
            let tt = 0; // start time
            let ap = ["AM", "PM"]; // AM-PM

            //loop to increment the time and push results in array
            for (let i = 0; tt < 24 * 60; i++) {
                let hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
                let mm = tt % 60; // getting minutes of the hour in 0-55 format

                let nextTime =
                    (hh == 12 ? "12" : "0" + (hh % 12)).slice(-2) +
                    ":" +
                    ("0" + mm).slice(-2) +
                    " " +
                    ap[Math.floor(hh / 12)];

                if (
                    moment(this.newCurrentDate + " " + nextTime, "YYYY-MM-DD hh:mm A").toDate() >= time1.date &&
                    moment(this.newCurrentDate + " " + nextTime, "YYYY-MM-DD hh:mm A").toDate() <= time2.date
                ) {
                    tt = tt + x;
                    continue;
                }
                tt = tt + x;
                times.push({
                    date: moment(this.newCurrentDate + " " + nextTime, "YYYY-MM-DD hh:mm A").toDate(),
                    free: true,
                    value: nextTime,
                });
            }
            return times;
        },

        appSwitch() {
            if (this.appointmentType === 'client') {
                this.apptClientSelected = true;
                this.disable = false;
                this.personal = false;

                this.newManageSaveAppointmentButton();
                this.resetData();
                return;
            }

            if (this.appointmentType === 'personal') {
                this.apptClientSelected = false;
                this.disable = true;
                this.personal = true;

                this.newManageSaveAppointmentButton();
                this.resetData();
                this.newTotalDurationServices = 10;
            }
        },

        changeTime(timeString) {
            if (typeof timeString == "undefined") {
                return;
            }
            this.hour = timeString;


            if (this.eventModalIsOpened) {
                this.showRescheduleSave = true;
            }
        },

        setAppointmentType(type) {
            this.appointmentType = type;
            this.appSwitch(); // keep your existing logic if needed
        },

        onDateClickFromDatePicker(date) {
            this.newCurrentDate = moment(date).format("YYYY-MM-DD");
            this.openDateModal = false;

            if (this.eventModalIsOpened) {
                this.openApptDetailsDateModal = false;
                this.showRescheduleSave = true;
            }

            this.newOnDateClick(
                {
                    date: date,
                },
                true
            );
        },

        showAllAppts() {
            this.handleDayButtonClick();
            const calendarApi = this.$refs.fullCalendar.getApi();
            // Switch to day view FIRST
            calendarApi.changeView('resourceTimeGridDay');

            // Track day state (unchanged)
            this.currentDayNumber = this.getDayNumber();

            // Persist state (unchanged)
            localStorage.setItem("ShowAllAppts", 1);

            // Disable stylist-specific mode
            this.showStylistSpecificAppointments = false;

            // Show ALL resources (v6-safe)
            this.filterMemberDisplayed(0);

            // Explicitly refetch events (v6 requirement)
            calendarApi.refetchEvents();
        },

        showStylistSpecificAppts() {
            this.showStylistSpecificAppointments = true;
            localStorage.removeItem("ShowAllAppts", 1);
            this.filterMemberDisplayed(this.newCurrentStylistId);
            this.showStylistSpecificApptsLogic();
        },

        showAllApptsLogic() {
            this.numberOfDataFetched = 0;
            this.totalNumberOfDataToFetch = 2 * this.newUsers.length;
            this.newUsers.forEach((user) => {
                this.newGetDisabledTimes(user);
                this.newGetAppointments(user);
            });
        },

        showStylistSpecificApptsLogic() {
            this.numberOfDataFetched = 0;
            this.totalNumberOfDataToFetch = 2;
            this.newGetDisabledTimes(this.newCurrentStylist);
            this.newGetAppointments(this.newCurrentStylist);
        },

        getGroupsMembers(group_id) {
            this.stylistsLoaded = true;

            this.$http.get(api.actions.get_stylist_group_members + group_id).then(
                function (response) {
                    if (typeof response.data.members != "undefined") {
                        this.groupMembers = _.filter(response.data.members, (el) => {
                            return el.active == 1;
                        });
                        this.editClientStylists.push(this.user.id);
                        this.editClientStylists.push(this.newCurrentStylist.user.id);

                        this.stylistsLoaded = false;
                    }
                }.bind(this)
            );
        },

        checkExistingTeamMemberUser() {
            var data = {
                phone: this.editClientObj.phone,
                email: this.editClientObj.email,
            };

            return this.$http.post(api.actions.verify_existing_user, data);
        },
        // Used in clients.js mixin file
        sendInvite() {
            let data = {
                phone: this.invitePhoneNumber,
                group_id: this.adminDetails.group_id,
                email: this.inviteEmail,
                app_id: this.generalOptions.app_id,
            };

            this.$http.post(api.actions.send_invite, data).then(
                function (response) {
                    if (response.data.error != true) {
                        this.displayNewClientForm = false;
                    }
                }.bind(this),
                function () {
                    return false;
                }
            );
        },

        onClientWidgetSlotSlick(date, hour) {
            if (this.loading) {
                return false;
            }

            let policy = this.clientWidgetSettings.stylist_policy;
            let deposit_fee = 0;

            if (policy && policy.deposit != 0 && policy.deposit_fee != 0) {
                if (policy.deposit_type == "fixed") {
                    deposit_fee = policy.deposit_fee;
                } else {
                    deposit_fee = (this.clientWidgetServicePrice * (policy.deposit_fee / 100)).toFixed(2);
                }
            }

            let formattedDate = moment(date + " " + hour, "YYYY-MM-DD hh:mm A").format("LLL");
            let message = '<div style="font-size:17px; color: black;">';
            message +=
                "Are you sure you want to book an appointment with " +
                this.clientWidgetSettings.stylist_name +
                " on " +
                formattedDate +
                "? ";

            if (deposit_fee) {
                message += "<br>Deposit Fee: <b>" + deposit_fee + this.clientWidgetSettings.stylist_currency + "</b>";
            }
            message += "</div>";

            let customClassApp = "rms-app";
            document.querySelector("body").classList.add("rms-app");

            if (this.generalOptions.app_id === 2) {
                customClassApp = "rmb-app";
                document.querySelector("body").classList.add("rmb-app");
            } else if (this.generalOptions.app_id === 5) {
                customClassApp = "rml-app";
                document.querySelector("body").classList.add("rml-app");
            }
            this.$swal({
                title: message,
                showCancelButton: true,
                customClass: customClassApp,
                confirmButtonText: "Yes",
                cancelButtonText: "No",
            }).then((result) => {
                if (result.value) {
                    let formattedDate = moment(date).format("YYYY-MM-DD");
                    let data = {
                        user_id: this.clientWidgetSettings.stylist_id,
                        client_id: this.user.id,
                        date_time: formattedDate,
                        hour: hour,
                        status: "unconfirmed",
                        total_duration: this.clientWidgetServiceDuration,
                        services: [this.clientWidgetSelectedService],
                        new_services: this.getServicesQty(),
                        notes: "",
                        special_event: "",
                        reminders: "",
                    };
                    this.loading = true;

                    if (deposit_fee) {
                        data.deposit_fee = deposit_fee;
                    }

                    this.$http.post(api.actions.save_appointment, data).then(
                        function (response) {
                            if (response.data.error == false) {
                                this.loading = false;
                                messages.successMessage(messages.GLOBAL_MESSAGES.APPOINTMENT_SCHEDULED);
                                this.getClientWidgetSettings();
                                this.newOnStylistChange();
                            }
                        }.bind(this),
                        function () {
                            return false;
                        }
                    );
                }
            });
        },

        getUserSupportMessages() {
            this.$http.get(api.actions.get_user_support_messages + "?ordering=desc").then(
                function (response) {
                    if (response.data.error) {
                        return;
                    }
                    if (
                        typeof response != "undefined" &&
                        typeof response.data != "undefined" &&
                        typeof response.data.supportMessages != "undefined" &&
                        response.data.supportMessages.length > 0
                    ) {
                        this.supportMessages = response.data.supportMessages;
                    }
                }.bind(this),

                function () {
                    return false;
                }
            );
        },

        getSupportMessagesStatus() {
            this.$http.get(api.actions.get_unread_support_messages_count).then(
                function (response) {
                    this.localNotificationCount = response.data.count;
                }.bind(this)
            );
        },

        addTimeToDate(date, timeInterval, intervalType) {
            return moment(date).add(timeInterval, intervalType).toDate();
        },

        onBook() {
            this.$router.push("/app/stylists");
        },

        bookAgain(stylistId) {
            this.bookData.id = 0;
            this.bookData.book_again = true;
            this.bookData.selected_service_qty = this.selectedServiceQty;

            // Event modal close
            const eventModalEl = document.getElementById("event-modal");
            const eventModalInstance = Modal.getInstance(eventModalEl) || new Modal(eventModalEl);
            eventModalInstance.hide();

            this.$router.push("/app/book/" + stylistId);
        },

        onModalClose() {
            // force unmount modal
            this.showCheckout = false;

            // optional but fine
            this.appointment_details = {};

            // close bootstrap modal
            const eventModalEl = document.getElementById("event-modal");
            const eventModalInstance = Modal.getInstance(eventModalEl) || new Modal(eventModalEl);
            eventModalInstance.hide();
        },

        isPastEvent(selectEvent) {
            let selectedEventDate = moment(selectEvent).unix();
            let currentDate = moment().unix();

            if (selectedEventDate < currentDate) {
                return true;
            }

            return false;
        },

        openDateModalWithClientSet() {
            const currentDate = moment().format("YYYY-MM-DD");
            const currentHour = moment().hours();
            const formattedHour = moment().hours(currentHour).format("hh:mm A");

            const openClientId = parseInt(sessionStorage.getItem("bookClientId"));
            const openClientFirstName = sessionStorage.getItem("bookClientFirstName");
            const openClientLastName = sessionStorage.getItem("bookClientLastName");

            if (!openClientId) {
                return;
            }

            sessionStorage.removeItem("bookClientId");
            sessionStorage.removeItem("bookClientFirstName");
            sessionStorage.removeItem("bookClientLastName");

            let client = {
                id: openClientId,
                first_name: openClientFirstName,
                last_name: openClientLastName,
            };

            this.changeTime(formattedHour);
            this.onDateClickFromDatePicker(currentDate);
            this.newSelectedClientF(client);

            // Open date modal
            const dateModalEl = document.getElementById("date-modal");
            const dateModalInstance = Modal.getInstance(dateModalEl) || new Modal(dateModalEl);
            if (dateModalInstance) {
                dateModalInstance.show();
            }

        },

        scrollTop() {
            setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });
            }, 500);
        },

        // Used in clients.js mixin file
        scrollToElement() {
            // Scroll to the element inside the modal
            this.$refs.scrollTarget.scrollIntoView({ behavior: "smooth" });
        },

        hourOnApptWasCreated() {
            let apptCreatedAt = this.appointment_details.details.created_at;

            // Convert the created_at time to local and format it
            const formattedHour = moment.utc(apptCreatedAt).local().format("hh:mm A");

            return formattedHour;
        },

        dayOnApptWasCreated() {
            let apptCreatedAt = this.appointment_details.details.created_at;

            // Convert the created_at time to local and format it
            const formattedDay = moment.utc(apptCreatedAt).local().format("MMMM D YYYY");

            return formattedDay;
        },

        capitalize(value) {
            if (!value) return "";
            return value.charAt(0).toUpperCase() + value.slice(1);
        },

        getBookedType(value, type) {
            if (!value) {
                return;
            }

            if (value == "client") {
                return value;
            }

            let val = "";

            switch (type) {
                case 1:
                    val = "stylist";
                    break;
                case 2:
                    val = "barber";
                    break;
                case 3:
                    val = "groomer";
                    break;
                case 5:
                    val = "loctician";
                    break;
                default:
                    val = value;
            }

            return val;
        },

        closeModal(modalId) {
            const closeModalEl = document.getElementById(`${modalId}`);
            const closeModalInstance = Modal.getInstance(closeModalEl) || new Modal(closeModalEl);
            closeModalInstance.hide();
        },

        toggleDatePicker() {
            this.newShowFullCalendarDatePicker =
                !this.newShowFullCalendarDatePicker
        },
        handleModalShow() {
            this.eventModalIsOpened = true;
        },

        handleModalHide() {
            this.eventModalIsOpened = false;
            this.showRescheduleSave = false;
        },
        sendSMSReminder() {
            let smsTextMessage = "";
            let appId = this.generalOptions.app_id;
            let linkType = "stylist";

            if (appId == 2) linkType = "barber";
            if (appId == 3) linkType = "groomer";
            if (appId == 5) linkType = "loctician";

            const formatedDateEvent = this.formatEventDate(this.unconfirmedApptObj.date);
            const token = encodeURIComponent(btoa(String(this.unconfirmedApptObj.id)));

            smsTextMessage = `Hi ${this.unconfirmedApptObj.with_name} you have an appointment with ${this.unconfirmedApptObj.stylist_name} on ${formatedDateEvent} https://www.ringmy${linkType}.com/confirm/${token}`;

            const data = {
                phone: this.unconfirmedApptObj.client_phone,
                text: smsTextMessage,
            };

            this.$http.post(api.actions.send_sms, data).then((res) => {
                if (res.data.error) {
                    messages.errorMessage(res.data.message);
                    return;
                }
                if (!res.data.error) {
                    messages.successMessage(messages.GLOBAL_MESSAGES.UNCONFIRMED_APPOINTMENT_REMINDER_MESSAGE_SENT);

                    const unconfirmedApptReminderModalEl = document.getElementById("unconfirmed-appt-reminder");
                    const unconfirmedApptReminderInstance = Modal.getInstance(unconfirmedApptReminderModalEl) || new Modal(unconfirmedApptReminderModalEl);
                    unconfirmedApptReminderInstance.hide();
                }
            });
        },
        getClientsNotifications() {
            this.gettingSettings = true;

            return this.$http.get(api.actions.get_clientnotifications).then((response) => {
                this.gettingSettings = false;

                if (response.data.notification_settings) {
                    this.notification_settings = response.data.notification_settings;
                    this.notification_settings_defaults = response.data.notification_settings_defaults;
                    this.datetime_formats = response.data.datetime_formats;

                    this.language = this.notification_settings.language;
                }
            });
        },
        handleUnconfirmedAppointmentReminder(event) {
            this.unconfirmedApptObj = event;
            const eventByStatusModalEl = document.getElementById("event-by-status-modal");
            const eventByStatusModalInstance = Modal.getInstance(eventByStatusModalEl) || new Modal(eventByStatusModalEl);
            eventByStatusModalInstance.hide();

            const unconfirmedApptReminderModalEl = document.getElementById("unconfirmed-appt-reminder");
            const unconfirmedApptReminderInstance = Modal.getInstance(unconfirmedApptReminderModalEl) || new Modal(unconfirmedApptReminderModalEl);
            unconfirmedApptReminderInstance.show();
        },
    },
    components: {
        FullCalendar,
        Datepicker,
        CompleteCheckoutModal,
        VueMultiselect,
        MainLoader,
    },
};
</script>